{
  "APPLICATION": {
    "TITLE": "Jグランツ ネットで簡単！補助金申請 | Jグランツ | Jグランツ",
    "NAME": "補助金申請サイト"
  },
  "BASE": {
    "CURRENCY": "円",
    "LOADING": "ロード中",
    "EMPTY": "−",
    "TILDE": "～"
  },
  "PAGINATOR": {
    "ITEMS_PER_PAGE_LABEL": "1ページあたりの件数:",
    "NEXT_PAGE_LABEL": "次へ",
    "PREVIOUS_PAGE_LABEL": "前へ",
    "FIRST_PAGE_LABEL": "最初へ",
    "LAST_PAGE_LABEL": "最後へ",
    "RANGE_PAGE_LABEL_1": "{{length}} 件中の 0",
    "RANGE_PAGE_LABEL_2": "{{length}} 件中の {{startIndex}} 件目～ {{endIndex}} 件目を表示"
  },
  "BUTTON": {
    "DELETE": "削除",
    "DRAFTDELETE": "削除する",
    "BACK": "戻る",
    "CLOSE": "閉じる",
    "EDIT": "編集する",
    "EDIT_STOP": "編集をやめる",
    "SAVE": "保存する",
    "SAVE_COMMENT": "コメントを保存する",
    "SAVE_NOT_DOC": "通知文書の情報を保存する",
    "SEARCH": "検索",
    "CSV_OUTPUT": "申請情報をCSV出力する",
    "RETURN_TO_LIST": "一覧に戻る",
    "APPLY": "申請する",
    "TEST_APPLY": "テスト申請する",
    "DELEGATION_APPLY": "代理申請する",
    "OK": "OK",
    "CANCEL": "キャンセル",
    "LOGIN_APPLY": "ログインして申請する",
    "SAVE_TEMP": "一時保存する",
    "RETURN_TO_EDIT": "編集に戻る",
    "DELEGATE_RETURN_TO_EDIT": "引き続き編集する",
    "DELEGATE_EDIT_END": "編集を終了する",
    "APPLICATION_INFO_SEARCH": "申請情報検索",
    "FILE_SELECT": "ファイルを選択",
    "FILE_CLEAR": "クリアする",
    "FILE_DOWNLOAD": "ダウンロード",
    "FILE_UPLOAD": "アップロード",
    "VIEW_PRINT": "表示・印刷する",
    "MASS_REVIEW": "一括審査",
    "GET_MIRASAPO_PLUS_INFO": "最新情報を取得する",
    "RETURN_TO_TOP": "トップへ戻る",
    "CONSULT": "問合せする",
    "LOGIN_CONSULT": "ログインして問合せする",
    "ADD_CONSULT": "追加で問合せする",
    "FREQUENTLY_ASKED_QUESTION": "よくあるお問合せ",
    "GO_TO_CONSULT_LIST": "問合せ一覧へ移動",
    "STAY_CURRENT": "元の画面に戻る",
    "SAVE_DRAFT": "下書き保存する",
    "SELECT": "選択する",
    "PROXY_NEW_REQUEST": "代理で新規作成する",
    "PROXY_VIEW_PROJECT": "代理で後続申請する",
    "PROXY_LOGOUT": "代理操作を終了",
    "APPLY_DELEGATION": "確認依頼する",
    "APPROVAL_APPLY": "確認依頼する",
    "APPROVAL_DELEGATION": "申請する",
    "APPROVAL": "申請する",
    "RETURN_DELEGATION": "代理申請者に訂正依頼する",
    "RETURN_DELEGATION_CONFIRM": "訂正依頼する",
    "WITHDRAW_DELEGATION": "申請を取り下げる",
    "WITHDRAW_DELEGATION_CONFIRM": "取り下げる",
    "ON_DELEGATION": "引き渡す",
    "ON_DELEGATION1": "代理申請者に",
    "ON_DELEGATION2": "編集権限を引き渡す",
    "ON_DELEGATION_HISTORY": "代理申請者に編集権限を引き渡す",
    "OFF_DELEGATION": "引き戻す",
    "OFF_DELEGATION1": "代理申請者から",
    "OFF_DELEGATION2": "編集権限を引き戻す",
    "OFF_DELEGATION_HISTORY": "代理申請者から編集権限を引き戻す",
    "ALTERNATIVE_DELEGATION": "編集を可能にする",
    "ALTERNATIVE_DELEGATION1": "別の代理申請者に",
    "ALTERNATIVE_DELEGATION2": "編集権限を引き渡す",
    "PROXY_APPLY": "代理申請する",
    "NEW_APPLY": "新規申請する",
    "PROXY_NEW_APPLY": "代理で新規申請する",
    "REGISTRATION": "登録",
    "RE_ENTER": "再入力",
    "CONTINUE": "続行",
    "BACK_TO_LIST": "一覧に戻る",
    "SELECT_DELEGATION": "選択",
    "DECIDE": "決定"
  },
  "NAVIGATION": {
    "LOGIN": "ログイン",
    "LOGOUT": "ログアウト",
    "LOGOUT_DELEGATION": "委任元選択の解除",
    "IS_DELEGATION": "委任元事業者",
    "NO_DELEGATION_RELATIONSHIP": "現在、委任関係が成立していない事業者です。",
    "NO_SHOW_OTHER_DELEGATION_RELATIONSHIP": "他のGビズアカウントの委任情報のため表示できません。",
    "SITE_SUMMARY": "このサイトは日本政府公式Webサイトです ▼",
    "DOMAIN": "「.go.jp」は政府公式サイトです。",
    "DOMAIN_DESCRIPTION": "政府公式サイトのドメインの多くは「**.go.jp」で終わります。電子申請等をされる際、政府公式サイトであることを確認してください。",
    "SSL": "このサイトは安全です。",
    "SSL_DESCRIPTION": "URLが「https://」で始まるサイトは、セキュリティ確保のためSSL(Secure Sockets Layer)技術を利用しています。当サイトを利用の際には、SSL技術タイプのブラウザをご利用ください。"
  },
  "FOOTER": {
    "COPYRIGHT": "デジタル庁（法人番号 8000012010038）<br>〒102-0094　東京都千代田区紀尾井町1-3　東京ガーデンテラス紀尾井町 19階<br>© 2020 Digital Agency, Government of Japan"
  },
  "HOME": {
    "TITLE": "ホーム",
    "INNER_TITLE": "ネットでいつでも！<br>補助金申請",
    "INNER_SUBTITLE": "Jグランツとは",
    "LABEL_TEXT_1": "デジタル庁が運営する補助金の",
    "LABEL_TEXT_2": "電子申請システムです。",
    "LABEL_TEXT_3": "24時間365日、手続きができます。",
    "IMPORTANCE": "重要なお知らせ",
    "FOR_BEGINNER": "初めての方へ",
    "JGRANTS_INFO_TITLE1": "Jグランツについて",
    "JGRANTS_DETAIL1_LABEL1": "デジタル庁が運営する補助金の電子申請システムです。24時間365日、手続きができます。",
    "JGRANTS_DETAIL1_LABEL2": "キーワードから目的の補助金を探せ、申請後はマイページから交付までの状況がわかります。",
    "JGRANTS_REQUEST_FLOW": "申請の流れはこちら",
    "JGRANTS_COMPANY_REGIST_GUIDE_TITLE": "自社情報の登録・更新について",
    "JGRANTS_COMPANY_REGIST_GUIDE1": "補助金申請をスムーズに行うために、事業者の基本情報（業種・従業員数・口座情報・財務情報など）を事前に登録してください。",
    "JGRANTS_COMPANY_REGIST_GUIDE2": "登録した情報は申請フォームに自動で反映され、入力負担の軽減や入力誤りの防止につながります。",
    "JGRANTS_COMPANY_REGIST_GUIDE3": "初めて利用する方はもちろん、既に登録済みの方も情報に変更があれば更新してください。",
    "JGRANTS_COMPANY_REGIST_GUIDE4": "自社情報の登録・更新ページはこちら",
    "JGRANTS_LABEL1": "24時間申請できる",
    "JGRANTS_LABEL2": "補助金を探しやすい",
    "JGRANTS_LABEL3": "申請状況がわかる",
    "JGRANTS_INFO_TITLE3": "申請に必要なGビズID",
    "JGRANTS_DETAIL3_LABEL1": "GビズIDは、1つのID・パスワードで様々な行政サービスにログインできるサービスです。",
    "JGRANTS_DETAIL3_LABEL4": "※「GビズIDプライム」（法人等の代表者アカウント）、「GビズIDメンバー」（代表者が許可した従業員用アカウント）がご利用いただけます。<a target='_blank' href='https://gbiz-id.go.jp/top/manual/manual.html'>詳細はこちら</a>",
    "NOTICE_IMPORTANT": "重要なお知らせ",
    "NOTICE": "お知らせ",
    "FOR_MINISTRIES_AND_GOVERNMENTS": "省庁・自治体の方へ",
    "EXPLANATION_1": "補助金の審査や交付をJグランツで行うことによって様々なメリットがあります。",
    "EXPLANATION_2": "補助金の電子申請をご検討の省庁・自治体の方へ"
  },
  "REQUEST_FLOW": {
    "TITLE": "申請の流れ",
    "APPLICATION": "①申請",
    "BUSINESS_IMPLEMENT": "②事業実施",
    "RECIEVE_SUBSIDY": "③補助金の受け取り",
    "MANUAL_URL_APPLICANT": "事業者クイックマニュアル",
    "COMMENTARY": "Jグランツで補助金を申請して受け取るまでには大きく3つのステップがあります。詳しくは補助金によって必要な手続きが異なります。",
    "COMMENTARY_DETAIL1": "※Jグランツの詳しい使い方はマニュアルをご覧ください。",
    "COMMENTARY_DETAIL2": "まずは補助金を探してみましょう！",
    "COMMENTARY_DETAIL3": "GビズIDの作成はこちら",
    "COMMENTARY_DETAIL4": "※GビズIDは、１つのⅠＤ・パスワードで様々な行政サービスにログインできるサービスです。",
    "SEARCH": "1．補助金を検索",
    "SEARCH_DETAIL1": "申請したい補助金を「補助金を探す」から検索する。",
    "ID_LOGIN": "2．GビズIDの取得／ログイン",
    "ID_LOGIN_DETAIL1": "申請したい補助金を見つけたら、GビズIDを取得して、ログインする。",
    "ID_LOGIN_DETAIL2": "※GビズIDの取得には２～３週間ほど時間がかかります。",
    "SEND": "3．公募の内容を入力して申請",
    "SEND_DETAIL1": "必要事項を入力し申請する。",
    "DELIVERY_SEND": "4．交付の内容を入力して申請",
    "DELIVERY_DETAIL1": "「マイページ」から対象の補助金を選択。必要事項を入力し申請する。",
    "IMPLEMENT": "5．マイページから必要な手続き",
    "IMPLEMENT_DETAIL1": "事業開始後、「事業計画の変更など」が発生したら必要な手続きをする。",
    "REPORT": "6．実績報告",
    "REPORT_DETAIL1": "事業または事業期間が終了したら、「マイページ」から「実績報告」をする。",
    "CLAIM": "7．請求",
    "CLAIM_DETAIL1": "「マイページ」から「精算払請求」をする。",
    "MAIL_RESULT": "審査結果をメールで受信",
    "MAIL_SUBSIDY_AMOUNT": "補助金額をメールで受信",
    "ADOPTED": "採択の決定",
    "DELIVERY": "交付の決定",
    "SUBSIDY_AMOUNT": "補助金額の確定",
    "ACCEPTANCE": "補助金の受け取り"
  },
  "SECRETARIAT_HOPER": {
    "TITLE": "補助金の電子申請をご検討の省庁・自治体の方へ",
    "DESCRIPTION_1_1": "公募から事業実施後まで",
    "DESCRIPTION_1_2": "全ての手続きを電子化",
    "DESCRIPTION_2_1": "申請者・事務局の方は",
    "DESCRIPTION_2_2": "利用料不要",
    "DESCRIPTION_3_1": "セットアップ操作のみで",
    "DESCRIPTION_3_2": "公募が開始できる",
    "DESCRIPTION_4_1": "運営事務局は",
    "DESCRIPTION_4_2": "ヘルプデスクがサポート",
    "DESCRIPTION_DATE": "※2021年2月時点",
    "WORKS": "導入の実績",
    "WORKS_DESCRIPTION": "Jグランツを活用している省庁・自治体が増えています。",
    "AIMING_FIGURE": "Jグランツの目指す姿",
    "AIMING_FIGURE_DESCRIPTION": "Jグランツは多くの省庁・自治体の方に活用いただきデータを一元的に管理することで、以下のような効果を今後実現したいと考えています。",
    "APPLICANT": "申請者",
    "APPLICATE_STRENGTHENING": "申請簡便化を強化",
    "ONCE_ONLY": "・ワンスオンリー<sup>※1</sup>",
    "RECOMMENDATION": "・リコメンドなど",
    "OFFICE": "事務局",
    "BUSINESS_STRENGTHENING": "事務効率化を強化",
    "REVIEW_AUTOMATION": "・審査自動化など",
    "POLICY_MAKER": "政策立案者",
    "DATA_STRENGTHENING": "データ利活用を強化",
    "EBPM": "・政策立案EBPM<sup>※2</sup>など",
    "ANNOTATION_1": "※1 提出した情報は、再提出不要",
    "ANNOTATION_2": "※2 エビデンスに基づく政策立案",
    "FLOW_OF_USE": "利用の流れ",
    "FLOW_1": "1.申請",
    "FLOW_DETAIL_1": "ご利用目的に応じて下記のボタンよりお申込みください。",
    "DEMO_USE_1": "デモ環境利用",
    "DEMO_USE_2": "操作感を体験したい方",
    "DEMO_USE_3": "デモ環境利用申請",
    "DEMO_APPLICATION_FORM_DOWNLOAD": "<a target='_blank' href='https://fs2.jgrants-portal.go.jp/Jグランツ_デモ環境利用申請フォーム.xlsx'>申請書ダウンロード</a>",
    "PRODUCTION_APPLICATION_FORM_DOWNLOAD": "<a target='_blank' href='https://fs2.jgrants-portal.go.jp/Jグランツ_アカウント発行申請フォーム.xlsx'>申請書ダウンロード</a>",
    "PRODUCTION_USE_1": "本番用アカウント登録",
    "PRODUCTION_USE_2": "本番環境を利用したい方",
    "PRODUCTION_USE_3": "アカウント登録申請",
    "FLOW_2": "2.アカウント発行",
    "FLOW_DETAIL_2_1": "お申込み後、ヘルプデスクより申請書類をお送りします。",
    "FLOW_DETAIL_2_2": "必要事項をご記入の上、ご返送ください。アカウントを発行します。",
    "FLOW_3": "3.補助金セットアップ",
    "FLOW_DETAIL_3": "マニュアルや動画を参照し、補助金公募に向けた登録を実施してください。",
    "USER_MANUAL": "Jグランツの利用マニュアル",
    "OVERVIEW": "概要説明の資料・動画",
    "OVERVIEW_DOCUMENT": "・概要説明資料",
    "VIDEO_DOCUMENT": "<a target='_blank' href='https://fs2.jgrants-portal.go.jp/Jグランツ概要.pdf'>Jグランツ概要</a>",
    "OPERATION_VIDEO": "・操作動画",
    "SECRETARIAT_VIDEO": "<a target='_blank' href='https://www.youtube.com/playlist?list=PLea04mU5mUmi4bT5ZnkYIN5WVa_9RhB5V'>事務局</a>",
    "EXTERNAL_JUDGE_VIDEO": "<a target='_blank' href='https://www.youtube.com/playlist?list=PLea04mU5mUmg4fE6Ysl1B3J1SlYS8nIhv'>外部審査員</a>",
    "BUSINESS_PERSON_VIDEO": "<a target='_blank' href='https://www.youtube.com/playlist?list=PLea04mU5mUmhxzf0HKkJTP6wNMS31ORXs'>事業者</a>",
    "MANAGEMENT_DETAIL": "※事務局管理者向けのものは、デモ環境または本番環境ログイン後ご確認いただけます。",
    "PDF_MANUAL": "PDFマニュアル等",
    "OPERATION_MANUAL": "・操作マニュアル",
    "SECRETARIAT_MANUAL": "<a target='_blank' href='https://fs2.jgrants-portal.go.jp/操作マニュアル_事務局用.pdf'>事務局</a>",
    "EXTERNAL_JUDGE_MANUAL": "<a target='_blank' href='https://fs2.jgrants-portal.go.jp/操作マニュアル_外部審査員用.pdf'>外部審査員</a>",
    "BUSINESS_PERSON_MANUAL": "<a target='_blank' href='https://fs2.jgrants-portal.go.jp/操作マニュアル_事業者サイト用.pdf'>事業者</a>",
    "QA_LIST": "・QA一覧",
    "FOR_SECRETARIAT_MANAGER_QA_LIST": "<a target='_blank' href='https://fs2.jgrants-portal.go.jp/mng/事務局管理者向けQAList.pdf'>事務局管理者向けQA一覧</a>",
    "SUBSIDY_SETUP": "・補助金セットアップ補助資料",
    "MATERIAL_FOR_CONSIDERATION": "<a target='_blank' href='https://fs2.jgrants-portal.go.jp/mng/検討用資料.xlsx'>検討用資料（エクセル）</a>",
    "CONTACT_US": "お問い合わせ先",
    "CONTACT_US_DETAIL_1": "事務局管理者アカウント登録完了時に送信するメールにてヘルプデスク連絡先をお伝えします。",
    "CONTACT_US_DETAIL_2": "なお、ヘルプデスク受付時間は平日9:00-17:00です。",
    "RECOMMENDED_SERVICE": "その他のおすすめサービス",
    "RECOMMENDED_SERVICE_DETAIL": "省庁、自治体の方が行政のデジタル化を進める上で活用できるサービスのご紹介です。",
    "DEMO_MAILTO": "mailto:info@mail.jgrants-portal.go.jp?subject=デモ環境利用の申請&body=下記を記入し、【デモ環境利用申請】のファイルを添付して、送付してください。%0d%0aご担当の補助金制度名：%0d%0a省庁・自治体名：%0d%0aご担当者氏名：",
    "DEMO_FORM_URL": "https://forms.office.com/pages/responsepage.aspx?id=_6DkBnJJi0qvMEVxNh0TRO0KQE4NmpNHpcsPOuPf6cFUNUdEOVBIR0VIQlpUSjlBRUtaMzMxSEI0WiQlQCN0PWcu&route=shorturl",
    "PRD_MAILTO": "mailto:info@mail.jgrants-portal.go.jp?subject=本番環境アカウント登録の申請&body=下記を記入し、【事務局管理者アカウント申請】のファイルを添付して、送付してください。%0d%0aご担当の補助金制度名：%0d%0a省庁・自治体名：%0d%0aご担当者氏名：",
    "PRD_FORM_URL": "https://forms.office.com/pages/responsepage.aspx?id=_6DkBnJJi0qvMEVxNh0TRO0KQE4NmpNHpcsPOuPf6cFUNzFPRzNEWjRQQlZTU0ZBNEsxSUFTUlhDRSQlQCN0PWcu&route=shorturl",
    "MIRA_SAPO_URL": "https://mirasapo-plus.go.jp/",
    "DSS_URL": "https://dss.linkdata.org/"
  },
  "FAQ": {
    "TITLE": "よくあるご質問",
    "ABOUT_JGRANTS": "Jグランツについて",
    "USAGE_ENVIRONMENT": "利用環境",
    "LOGIN": "ログイン",
    "SUBSIDY": "補助金への応募",
    "CHATBOT_TITLE": "チャットボットでもご案内しています",
    "ABOUT_JGRANTS_TITLE": "１．Jグランツについて",
    "USAGE_ENVIRONMENT_TITLE": "２．Jグランツの利用環境",
    "CHATBOT_DETAIL_LABEL1": "画面右下のチャットボットを押下し、質問文を入力又は表示されるカテゴリから選択してください。",
    "CHATBOT_DETAIL_LABEL2": "スムーズに見つけるヒント：",
    "CHATBOT_DETAIL_LABEL3": "カテゴリからの選択か短文・単語での入力が円滑です。なお、補助金個別のご質問はチャットボットではお答えできませんので補助金ごとのお問い合わせ窓口にお問い合わせください。",
    "CHATBOT_DETAIL_LABEL4": "チャットボットでご案内中の全てのQAをPDF形式で",
    "DOWNLOAD": "ダウンロード",
    "LOGIN_TITLE": "３．Jグランツへのログイン",
    "SUBSIDY_TITLE": "４．補助金への応募/申請入力",
    "Q1_1_TITLE": "補助金とは何ですか。",
    "Q1_1_DETAIL1": "補助金は、国や自治体の政策目標（目指す姿）に合わせてさまざまな分野で募集されており、事業者の取り組みをサポートするために資金の一部を給付するというものです。返済する必要はありません。",
    "Q1_1_DETAIL2": "をご参照ください。",
    "Q1_1_DETAIL3": "また、補助金は後払い（精算払い）ですので、事業の実施後に必要書類を提出して検査を受けた後に受け取ることができます。",
    "Q1_1_DETAIL4": "詳しくは、以下中小企業向け補助金・総合支援サイトをご参照ください。",
    "Q1_2_TITLE": "Jグランツとは何ですか。どの機関が運営していますか。",
    "Q1_2_DETAIL1": "Jグランツとは、デジタル庁が運営する補助金の電子申請システムです。",
    "Q1_2_DETAIL2": "いつでも・どこでも申請が可能であり、交通費・郵送費等のコスト削減や、過去に申請した情報の入力や書類への押印が不要になるなど、事業者の皆様における手間やコスト削減を目的としたシステムです。",
    "Q1_2_DETAIL3": "Jグランツで申請のできる補助金は、随時拡大しています。",
    "Q1_2_DETAIL4": "Jグランツは法人、個人事業主、地方公共団体等どなたでも無料でご利用いただけますが、申請の提出にはGビズIDが必要となります。",
    "Q1_3_TITLE": "Jグランツの操作方法が知りたいです。",
    "Q1_3_DETAIL1": "操作方法につきましては、マニュアルにて確認することができます。",
    "Q1_3_DETAIL2": "画面上部の「申請の流れ」ページから、",
    "Q1_3_LINK": "「事業者クイックマニュアル」",
    "Q1_3_DETAIL3": "をご参照ください。",
    "Q1_4_TITLE": "Jグランツから補助金を申請するために、何か準備が必要なものはありますか。",
    "Q1_4_DETAIL1": "応募したい補助金が見つかり、Jグランツから電子申請で応募するには、GビズIDの取得が必要です。",
    "Q1_4_DETAIL2": "■GビズIDとは",
    "Q1_4_DETAIL3": "法人又は個人事業主の方が各種行政サービスを電子申請頂く際にご利用いただけるログインアカウントです。",
    "Q1_4_DETAIL4": "■Jグランツ利用可能なGビズIDの種別",
    "Q1_4_DETAIL5": "・GビズIDプライム（法人等の代表者アカウント）",
    "Q1_4_DETAIL6": "・GビズIDメンバー（組織の従業員用アカウントとしてプライムが許可したアカウント）",
    "Q1_4_DETAIL7": "GビズID未取得の場合、まずはGビズIDプライムを申請してください。その後、組織の従業員用アカウントとしてGビズIDメンバーを発行する場合は即日発行が可能です。",
    "Q1_4_DETAIL8": "なお、補助金ごとの必要な準備資料につきましては、補助金によって異なります。ログイン前でも交付要綱や公募要領等から必要な準備資料を確認することが可能ですので、画面上部の「補助金一覧」メニューより該当補助金を押下いただき、ダウンロードしてご参照ください。",
    "Q1_5_TITLE": "Jグランツから申請できる補助金は、どこで確認できますか。",
    "Q1_5_DETAIL1": "Jグランツのトップページにある「補助金を探す」から検索いただくと、現在受付中の補助金が一覧で表示されます。",
    "Q1_5_DETAIL2": "「募集予定の補助金」や「募集終了の補助金」を確認したい場合は、検索画面でそれぞれのチェックボックスにチェックを入れて検索してください。",
    "Q1_5_DETAIL3": "また、「キーワードで検索」欄では、補助金名や事業内容を表すキーワード（例：「脱炭素」「持続化」など）での検索が可能です。複数のキーワードで検索する場合は、キーワードの間にスペースを入れてください。",
    "Q1_5_DETAIL4": "そのほかにも、「条件で探す」「テーマで探す」などの方法で、目的に合った補助金を絞り込むことができます。",
    "Q1_6_TITLE": "Jグランツから補助金申請ができない申請者はいますか。",
    "Q1_6_DETAIL1": "補助金の申請条件は補助金ごとにルールが異なりますので、画面上部の「補助金を探す」メニューより該当補助金をクリックいただき、交付要綱や公募要領等をダウンロードしてご確認ください。",
    "Q1_6_DETAIL2": "なお、Jグランツから補助金申請を行うには、GビズIDが必要です。GビズIDプライムもしくはGビズIDメンバーをお持ちでない場合はJグランツからの申請は行えません。",
    "Q2_1_TITLE": "Jグランツを操作するにあたって、利用可能な端末は何ですか。",
    "Q2_1_DETAIL1": "指定のブラウザが利用可能な端末の制限はなく、パソコンのほかスマートフォンやタブレットからも閲覧可能です。なお、申請にあたっては必要書類のファイルアップロード等が求められる場合がありますので、これらが可能な環境をご用意ください。",
    "Q2_2_TITLE": "利用可能なブラウザは何ですか。",
    "Q2_2_DETAIL1": "Jグランツの動作環境は以下のとおりです。下記のブラウザの最新バージョンをご利用ください。",
    "Q2_2_DETAIL2": "なお、InternetExplorer等の下記以外のブラウザは、申請上のエラー等が生じますので利用しないでください。",
    "Q2_2_DETAIL3": "・Windows",
    "Q2_2_DETAIL4": "：chrome、firefox、edge(※1)",
    "Q2_2_DETAIL5": "・macOS",
    "Q2_2_DETAIL6": "：chrome、firefox、safari",
    "Q2_2_DETAIL7": "・Android",
    "Q2_2_DETAIL8": "：chrome",
    "Q2_2_DETAIL9": "※1 edgeの「InternetExplorerモード」は申請上のエラー等が生じますので利用しないでください。",
    "Q3_1_TITLE": "ログインできません。どうすれば良いでしょうか。",
    "Q3_1_DETAIL1": "ログインID、パスワードが正しいことをご確認ください。また、GビズIDプライムもしくはGビズIDメンバー以外の「GビズIDエントリー」ではログインできませんので、GビズIDの種別をご確認ください。Q1-4もご参照ください。",
    "Q3_1_DETAIL2": "GビズIDについてのご不明点は、マニュアルをご確認ください。",
    "Q3_1_DETAIL3": "GビズID　マニュアル・様式等のダウンロードページ",
    "Q3_1_DETAIL4": "GビズIDクイックマニュアルGビズIDプライム編",
    "Q3_1_DETAIL5": "GビズIDクイックマニュアルGビズIDメンバー編",
    "Q3_1_DETAIL6": "＜GビズID ヘルプデスク＞",
    "Q3_1_DETAIL7": "GビズID ヘルプデスクはこちらを参照ください。（外部リンク）",
    "Q3_2_TITLE": "パスワードを忘れました。どうしたら良いでしょうか。",
    "Q3_2_DETAIL1": "GビズIDの「ログイン」画面（",
    "Q3_2_DETAIL2": "）から、「ログイン」ボタン下の「パスワードを忘れた場合」をクリックし、メッセージに従って操作を行ってください。",
    "Q3_3_TITLE": "パスワード発行・再発行のためのメールが届きません。どうしたら良いでしょうか。",
    "Q3_3_DETAIL1": "メールが届かない場合、まずは以下をご確認ください。",
    "Q3_3_DETAIL2": "＜ケース１＞登録メールアドレスの確認：登録メールアドレスが誤っていないか、ご確認をお願いいたします。",
    "Q3_3_DETAIL3": "＜ケース２＞迷惑メール設定、迷惑メールフォルダーの確認：受信側の迷惑メール設定や受信拒否設定、なりすまし規制等により、迷惑フォルダや削除フォルダ等にメールが自動で振り分けられている可能性が考えられます。振り分け設定や、迷惑フォルダ等のご確認をお願いいたします。",
    "Q3_3_DETAIL4": "上記で解決しない場合は、ヘルプデスクにお問合せください。",
    "Q3_3_DETAIL5": "＜GビズID ヘルプデスク＞",
    "Q4_1_TITLE": "補助金はどこから申請できますか。",
    "Q4_1_DETAIL1": "「補助金を探す」メニューから該当する補助金名をクリックすると、その補助金の詳細ページが表示されます。ページを一番下までスクロールすると、「申請する」ボタンが表示されますので、そちらをクリックしてください。",
    "Q4_1_DETAIL2": "補助金によっては、地域・年度・募集回ごとに申請窓口が分かれている場合があります。その場合は、それぞれに対応した「申請する」ボタンが表示されますので、公募要領をご確認のうえ、該当するボタンをクリックしてください。",
    "Q4_1_DETAIL3": "なお、申請にはGビズIDプライムまたはGビズIDメンバーのアカウントでのログインが必要です。",
    "Q4_2_TITLE": "操作方法、および入力内容に関する説明はどこで確認できますか。",
    "Q4_2_DETAIL1": "操作方法につきましては、操作マニュアルにて確認することができます。",
    "Q4_2_DETAIL2": "「申請の流れ」ページから、",
    "Q4_2_DETAIL3": "申請フォームへの入力内容については、補助金ごとに異なりますので、トップページの「補助金を探す」から申請対象の補助金名をクリックし、公募要領や電子申請マニュアルの掲載があれば当該資料をダウンロードしてご参照ください。申請フォーム画面上にも記載例等が明記されている場合がありますので、あわせてご参照ください。",
    "Q4_3_TITLE": "補助金のページで、申請の作成ボタンが見当たりません。",
    "Q4_3_DETAIL1": "以下の場合は、申請の作成ボタンが表示されません。",
    "Q4_3_DETAIL2": "・募集期間外である場合",
    "Q4_3_DETAIL3": "・複数申請不可の補助金で、既に申請を一つ作成されている場合",
    "Q4_3_DETAIL4": "・Jグランツでは情報掲載のみで、申請受付を行っていない場合",
    "Q4_3_DETAIL5": "上記をご確認の上、不明点がある場合は補助金ごとの問い合わせ窓口へご連絡ください。",
    "Q4_4_TITLE": "入力した申請情報を提出前に修正・変更する可能性がある場合、どのようにすれば良いでしょうか。",
    "Q4_4_DETAIL1": "マイページの「申請履歴」の一覧で、対象の事業名をクリックし、「作成済みの申請」で該当の申請をクリックしてください。申請状況が「申請済み」の場合は、修正できませんのでご注意ください。",
    "Q4_5_TITLE": "一時保存した申請情報の提出方法が分からない。",
    "Q4_5_DETAIL1": "マイページの「申請履歴」の一覧で、対象の事業名をクリックし、「作成済みの申請」で該当の申請をクリックすることで編集できます。事業名未記入の場合（タイトルなし）と表示されます。",
    "Q4_5_DETAIL2": "提出する際は、画面最下部の「申請する」ボタンを押下してください。注意の記載されたポップアップが表示されますので、確認のうえ、再度、「申請する」ボタンを押下してください。",
    "Q4_6_TITLE": "申請の提出が完了できているのかどうか、確認する方法を知りたい。",
    "Q4_6_DETAIL1": "マイページの「申請履歴」の一覧で、対象の事業名をクリックし、「作成済みの申請」で該当の申請の「申請状況」および「申請完了日時」をご確認ください。",
    "Q4_6_DETAIL2": "ステータスが 「申請済み」かつ申請完了日時に日付と時間が入っていれば、申請の提出が完了しております。",
    "Q4_6_DETAIL3": "ステータスが「下書き中」かつ申請完了日時が空欄の場合は、事務局への提出は完了しておりませんのでご注意ください。",
    "Q4_7_TITLE": "申請後にマイページで申請情報を確認しようとしたが、申請情報が表示されない。申請できていないということでしょうか。",
    "Q4_7_DETAIL1": "申請情報が反映されるまで数分かかる場合があります。恐れ入りますが、しばらく時間をおいてマイページ画面を更新しご確認ください。",
    "Q4_7_DETAIL2": "一定時間経過しても申請情報が表示されない場合は、事務局へお問い合わせください。",
    "Q4_8_TITLE": "口座確認とは何ですか？口座確認の結果はどこで見られますか。",
    "Q4_8_DETAIL1": "自社情報の確認・編集画面、または概算払請求/精算払請求の申請時にて、補助金受取用の口座を登録することができます。",
    "Q4_8_DETAIL2": "口座登録時には、金融機関、支店、預貯金種別、口座番号、口座名義（カナ）を用いて、口座の実在性確認（口座確認）を行います。",
    "Q4_8_DETAIL3": "口座確認の結果は、自社情報の確認・編集画面にて口座確認のステータスとして確認が可能です。",
    "Q4_8_DETAIL4": "詳細は、<a target='_blank' href='https://fs2.jgrants-portal.go.jp/操作マニュアル_事業者用.pdf'>事業者マニュアル「Ⅳ. 事業開始後の各種手続き」</a>をご参照ください。",
    "Q4_8_TABLE_HEADER1": "口座確認のステータス",
    "Q4_8_TABLE_HEADER2": "概要",
    "Q4_8_TABLE_LEFT_DATA1": "確認済み",
    "Q4_8_TABLE_LEFT_DATA2": "名義不一致",
    "Q4_8_TABLE_LEFT_DATA3": "口座確認対象外",
    "Q4_8_TABLE_LEFT_DATA4": "確認中",
    "Q4_8_TABLE_LEFT_DATA5": "口座不存在",
    "Q4_8_TABLE_DATA1": "入力情報どおりの口座番号、口座名義（カナ）が存在することが確認された場合に設定。",
    "Q4_8_TABLE_DATA2": "口座番号の存在は確認できたが、口座名義（カナ）が確認できなかった場合に設定。",
    "Q4_8_TABLE_DATA3": "口座確認ができない金融機関・口座だった場合に設定。",
    "Q4_8_TABLE_DATA4": "一時的に、口座確認ができなかった場合に設定。翌朝にあらためて自動で口座確認を実施。",
    "Q4_8_TABLE_DATA5": "口座番号が存在しないと判定された場合に設定。",
    "Q4_8_TABLE_DATA6": "「確認中」となった翌朝の口座確認にて「口座不存在」と判定された場合には、",
    "Q4_8_TABLE_DATA7": "• 自社情報の確認・編集画面の口座情報：削除されます。",
    "Q4_8_TABLE_DATA8": "• 申請書上の口座情報：削除されず、「口座不存在」ステータスがセットされます。"
  },
  "OPEN_API": {
    "TITLE": "API",
    "API_TITLE1": "補助金情報取得API",
    "API_NAME_TITLE": "API名称・仕様",
    "API_OVERVIEW_TITLE": "概要",
    "API_METHOD_TITLE": "メソッド",
    "API_INFO_TITLE": "情報",
    "API_NAME_LINK1": "補助金一覧取得API",
    "API_OVERVIEW1": "検索条件に合致する補助金の基本情報をデータベースより複数取得し、一覧形式で返却します。",
    "API_METHOD1": "GET",
    "API_INFO1": "補助金基本情報",
    "API_NAME_LINK2": "補助金詳細取得API",
    "API_OVERVIEW2": "補助金一覧取得APIで受け取った補助金IDを一件指定し、当該補助金の詳細情報を取得します。",
    "API_METHOD2": "GET",
    "API_INFO2": "補助金詳細情報",
    "OVERVIEW_TITLE": "機能概要",
    "OVERVIEW_DETAIL_LABEL1": "・Jグランツの補助金データベースから補助金情報を取得し、補助金情報の紹介等補助金データの利活用を可能とします。",
    "OVERVIEW_DETAIL_LINK": "・利用概要はこちら",
    "DATA_STRUCTURE_TITLE": "データ構造",
    "API_STIPULATION_TITLE": "API利用規約",
    "API_STIPULATION_LINK": "・API利用規約はこちら"
  },
  "STIPULATION": {
    "TITLE": "利用規約",
    "TOP": "Ｊグランツ 利用規約",
    "DEVELOPMENT_DAY": "2020年12月24日制定<br>2021年9月1日改訂<br>2025年9月26日改訂",
    "METI": "デジタル庁",
    "PURPOSE": "第１条（目的等）",
    "PURPOSE_MESSAGE_1": "１　Ｊグランツ利用規約（以下「本利用規約」といいます。）は、デジタル庁が運営・提供するＪグランツの利用に関し、利用者に同意していただくことが必要な事項を定めることを目的とします。",
    "PURPOSE_MESSAGE_2": "２　利用者は、本利用規約に同意した上で、本利用規約の規定を遵守して本サービスを利用するものとします。",
    "DEFINITION": "第２条（定義）",
    "DEFINITION_MESSAGE_1": "　本利用規約において、次の各号に掲げる用語の定義は、当該各号に定めるとおりとします。",
    "DEFINITION_MESSAGE_1_1": "一　「デジタル庁ウェブサイト」とは、そのドメインがjgrants-portal.go.jpである、デジタル庁が運営するウェブサイト（理由の如何を問わず、デジタル庁のウェブサイトのドメイン又は内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。",
    "DEFINITION_MESSAGE_1_2": "二　「本サービス」とは、デジタル庁が提供するＪグランツという名称のサービス（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。本サービスの内容について、詳細は第５条及び第１９条第１項に規定されています。",
    "DEFINITION_MESSAGE_1_3": "三　「本サービス提供者」とは、本サービスのシステム管理、運営主体としてのデジタル庁を意味します。",
    "DEFINITION_MESSAGE_1_4": "四　「申請」とは、本サービスを利用した、補助金等の申請に関する一切の手続きを意味します。",
    "DEFINITION_MESSAGE_1_5": "五　「利用者」とは、本サービスを利用して補助金等の申請を行う者を意味します。",
    "DEFINITION_MESSAGE_1_6": "六　「事務局」とは、各補助金等に関する公募条件の設定、申請内容の審査（形式の確認も含みます。）、交付決定その他補助金等の交付に係る業務を所掌する組織又は主体を意味します。",
    "DEFINITION_MESSAGE_1_7": "七　「交付要綱」とは、各補助金等の交付に関する共通的な事項につき事務局が定めたものを意味します。",
    "DEFINITION_MESSAGE_1_8": "八　「公募要領」とは、補助金等の申請資格、申請期間、必要な添付書類等の申請に当たって確認が必要な事項につき事務局が定めたものを意味します。",
    "DEFINITION_MESSAGE_1_9": "九　「口座情報」とは、金融機関の名称、店舗（本支店等）の名称、預貯金の種別、口座番号又は記号番号及び口座名義（カタカナ表記）を意味します。",
    "DEFINITION_MESSAGE_1_10": "十　「口座情報確認」とは、利用者が本サービスを利用した電子申請で、次号に定める補助金等受取口座として使用する口座情報を入力する場合に、本サービスから外部の口座確認サービスを通じ、金融機関に対して当該口座に関する情報を照会した上で、口座情報の実在性を確認することを意味します。",
    "DEFINITION_MESSAGE_1_11": "十一　「補助金等受取口座」とは、各行政機関の長等が行う公的給付の支給等に係る金銭の授受に利用することのできる預貯金口座を意味します。",
    "SCOPE": "第３条（他の規程との関係）",
    "SCOPE_MESSAGE_1": "１　本サービス提供者が別途求める同意事項や別途公表する本サービスの利用条件・諸注意等（以下「諸注意等」といいます。）が存在する場合、諸注意等は本利用規約の一部を構成するものとします。",
    "SCOPE_MESSAGE_2": "２　本利用規約の内容と、諸注意等が異なる場合は、本利用規約の規定が優先して適用されるものとします。",
    "USERS": "第４条（利用者）",
    "USERS_MESSAGE_1": "　本サービスを利用することができる者は、事務局が定める交付要綱及び公募要領等に基づき、申請の資格を有する者であることとします。",
    "PROVIDE": "第５条（本サービスの提供範囲）",
    "PROVIDE_MESSAGE_1": "１　本サービスは、利用者による各補助金等の検索及び申請、並びに利用者と事務局間の補助金等の交付に関する通知を支援する機能その他付随する機能を提供するものです。",
    "PROVIDE_MESSAGE_2": "２　本サービス提供者（その運営を委託された外部事業者を含みます。）は、事務局が所掌する各補助金等の公募条件の設定、申請内容の審査（形式の確認も含みます。）、交付決定その他補助金等の交付に係る業務を提供するものではありません。また、本サービスにおいて掲載される各補助金等に関する情報については、事務局から提供を受けた情報が本サービスにおいて掲載されるのみであり、その内容の正確性については事務局において管理されるサービスです。",
    "PROVIDE_MESSAGE_3": "３　事務局の申請に関する処理の遅延、交付決定の中止、申請の停止若しくは取消し又は利用者が提供した情報の流出又は消失その他本サービスの提供範囲に含まれず利用者と事務局との間におけるトラブル等については、利用者と事務局において解決するものとします。",
    "PRINCIPLE": "第６条（自己責任の原則）",
    "PRINCIPLE_MESSAGE_1": "１　利用者は、事務局が策定する個別の交付要綱及び公募要領等に記載のある申請者の資格、申請の時期、申請に必要な添付書類又はその他の条件について十分理解した上で本サービスにおいて申請を実施することとします。これらの事実につき利用者が知らなかったこと又は利用者における解釈の誤りに起因する損害については利用者が責任を負うものとします。",
    "PRINCIPLE_MESSAGE_2": "２　利用者は申請に関するシステム上の操作、システムの停止期間及びその他の申請に関する事項について、十分に注意し確認を行った上で行うものとします。利用者が操作を誤ったこと、申請に関する確認を怠ったこと又は通常想定される以外の方法で本サービスを利用したことに起因する損害については利用者が責任を負うものとします。",
    "PRINCIPLE_MESSAGE_3": "３　利用者は、本サービスの利用に際して第三者又は本サービス提供者（その運営を委託された外部事業者を含みます。）に損害又は不利益を与えた場合、利用者が当該損害を賠償する責任を負うものとします。",
    "ACCOUNT": "第７条（アカウントの取得手続等）",
    "ACCOUNT_MESSAGE_1": "１　利用者は、本サービスの利用に先立ち、デジタル庁が提供するＧビズＩＤサービスにおいて、アカウントを取得することとします。",
    "ACCOUNT_MESSAGE_2": "２　利用者は、ＧビズＩＤサービスにおけるアカウントの取得その他同サービスの利用において、同サービスの利用規約及びプライバシーポリシーに同意した上でこれを行うものとします。",
    "ACCOUNT_MESSAGE_3": "３　利用者は、利用者のGビズＩＤアカウントが停止された場合又は利用者がGビズIDアカウントの退会を行った場合、本サービスが利用できなくなるものとします。",
    "ACCOUNT_MESSAGE_4": "４　退会後の利用者情報の取扱いについては、第２０条（個人情報等の取扱い）の規定に従うものとします。",
    "CAUTION": "第８条（申請に関する留意事項）",
    "CAUTION_MESSAGE_1": "１　利用者は、申請を実施するに当たって、自己に申請資格があることを確認の上、適正な申請を実施すべき義務を負うものとします。",
    "CAUTION_MESSAGE_2": "２　利用者が本サービスを利用して不正な申請その他の補助金等の手続に関する不適切な行為に及んだ場合は、補助金等の予算の執行の適正化に関する法律第29条から第33条までの規定その他の法律の規定、個別の補助金等の交付要綱等の規定又は所管省庁等における行政処分等に基づく罰則の適用を受ける場合があります。",
    "NOTIFY": "第９条（通知を受けるための事項）",
    "NOTIFY_MESSAGE_1": "１　利用者は、本サービスを利用した申請にかかる交付決定その他のこれに準ずる各種通知については、利用者が第3項に基づいて書面での通知を求める場合を除き、電子メール、マイページ機能その他電磁的な方法（以下「電磁的方法」といいます。）によって行うことに同意します。",
    "NOTIFY_MESSAGE_2": "２　利用者は、前項における電磁的方法での通知を受けるに当たって、利用者が通知を希望するメールアドレスを本サービスに登録するものとし、その登録をもって、当該メールアドレスに通知がなされることに同意します。",
    "NOTIFY_MESSAGE_3": "３　利用者は、第１項に基づき各種通知について書面での通知を求める場合、本サービス提供者が別途に定める方法に従い、その旨を本サービス提供者が定める相手方に通知するものとします。",
    "NOTIFY_MESSAGE_4": "４　第１項に定める電磁的方法での通知を受けるに当たって、利用者側のメールの受信設定又は利用するメールソフト等に起因する通知の未達があった場合において、本サービス提供者（その運営を委託された外部事業者を含みます。）は責任を負いません。",
    "NOTIFY_MESSAGE_5": "５　第１項に定める通知を除く本サービス提供者から利用者への通知は、本利用規約に特段の定めのない限り、通知内容を書面若しくは電磁的方法又は通知内容をデジタル庁ウェブサイトに掲載する等、本サービス提供者が適当と判断する方法により行います。 ",
    "NOTIFY_MESSAGE_6": "６　前項の規定に基づき、本サービス提供者から利用者への通知を、電磁的方法又はデジタル庁ウェブサイトへの掲載の方法により行う場合には、利用者に対する当該通知は、それぞれファイルの送信又はデジタル庁ウェブサイトへの掲載がなされた時点から効力を生じるものとします。",
    "NOTIFY_MESSAGE_7": "７　第１項で利用者が書面での通知を求めたとき、又は第５項に基づき、本サービス提供者が利用者に対し書面での通知を行う際、本サービス提供者が、利用者の届け出た住所に宛てて利用者への通知を発した場合には、当該通知が延着又は不着となったときであっても、通常到達すべき時に到達したものとみなします。",
    "OBLIGATION": "第１０条（企業の秘密に関する利用者の義務）",
    "OBLIGATION_MESSAGE_1": "１　申請に当たって、利用者が企業の秘密を提出する必要が生じた場合においては、当該企業秘密漏洩のリスク等を自ら評価し、申請を実施するものとします。",
    "OBLIGATION_MESSAGE_2": "２　前項において、利用者が当該リスクを許容できないものと評価した場合、自己の判断において本サービスを利用しないこと又はその他の手段によって当該秘密を提出するものとします。",
    "PROHIBITION": "第１１条（禁止事項）",
    "PROHIBITION_MESSAGE_1": "　利用者は、次の各号のいずれかに該当する行為又は該当するおそれのある行為を行ってはならないものとします。",
    "PROHIBITION_MESSAGE_1_1": "一　虚偽の内容に基づく申請を行うこと",
    "PROHIBITION_MESSAGE_1_2": "二　不正に取得した書類等を添付して申請を行うこと",
    "PROHIBITION_MESSAGE_1_3": "三　本サービスの利用者たる地位、利用者として保有する権利、利用者として負う義務又は申請及び当該申請にかかる通知によって取得した契約上の地位を、本サービス提供者若しくは事務局のうち法律上承諾を取得すべき者又は法律上必要がある場合にはその両者から事前の書面又は電磁的な方法による承諾なくして第三者に譲渡すること",
    "PROHIBITION_MESSAGE_1_4": "四　本サービスの運営を妨げ、又は本サービス提供者の信用を毀損する行為",
    "PROHIBITION_MESSAGE_1_5": "五　本サービスの他の利用者又は事務局に不当に不利益を及ぼす行為",
    "PROHIBITION_MESSAGE_1_6": "六　本利用規約、交付要綱、公募要領等若しくは法令に違反する行為又は公序良俗に反する行為",
    "PROHIBITION_MESSAGE_1_7": "七　本サービスに不正にアクセスする行為",
    "PROHIBITION_MESSAGE_1_8": "八　他者になりすます行為",
    "PROHIBITION_MESSAGE_1_9": "九　他者を差別し、誹謗中傷し、又は他者の名誉若しくは信用を毀損する行為",
    "PROHIBITION_MESSAGE_1_10": "十　本サービスのネットワーク又はシステム等に対し、ウィルスに感染したファイルを送信する行為",
    "PROHIBITION_MESSAGE_1_11": "十一　本サービスのネットワーク又はシステム等に過度な負荷をかける行為",
    "PROHIBITION_MESSAGE_1_12": "十二　本サービスの本来の目的以外の目的で本サービスを利用する行為",
    "PROHIBITION_MESSAGE_1_13": "十三　前各号に掲げるもののほか、本サービスの運営に支障を来し、又は第三者に損害を与える行為",
    "GUARANTEE": "第１２条（表明保証）",
    "GUARANTEE_MESSAGE_1": "　利用者は、本利用規約に同意する時点において次の各号のいずれにも該当しないことを表明し、将来にわたって次の各号のいずれにも該当しないことを確約するものとします。",
    "GUARANTEE_MESSAGE_1_1": "一　自己又は自社の役員（取締役、執行役又は監査役）が、暴力団（暴力団員による不当な行為の防止等に関する法律（平成３年法律第７７号）第２条第２号）、暴力団員（同法同条第６号）、暴力団員でなくなった時から５年間を経過しない者若しくはこれらに準ずる者又は暴力団若しくは暴力団員と密接な関係を有する者（以下これらを個別に又は総称して「暴力団員等」といいます。）であること。",
    "GUARANTEE_MESSAGE_1_2": "二　実施する事業が、暴力団員等の支配を受けていると認められること。",
    "GUARANTEE_MESSAGE_1_3": "三　事業の実施に当たって、暴力団員等の威力を利用し、財産上の不当な利益を図る目的で暴力団員等を利用し、又は暴力団員等の威力を利用する目的で暴力団員等を従事させていると認められること。",
    "GUARANTEE_MESSAGE_1_4": "四　暴力団員等に対して資金を提供し、便宜を供与し、又は不当に優先的に扱う等の関与をしていると認められること。",
    "GUARANTEE_MESSAGE_1_5": "五　本サービスにおける申請が、暴力団員等の活動を助長し、又は暴力団の運営に資するものであること。",
    "RESTRICTION": "第１３条（本サービスの利用制限等）",
    "RESTRICTION_MESSAGE_1": "　次の各号に定める場合のいずれかが生じたときは、本サービス提供者はその判断により、利用者にあらかじめ通知することなく 、本サービスの利用を制限、停止又はすでにされた申請に係るデータの削除をすることができるものとします。",
    "RESTRICTION_MESSAGE_1_1": "一　利用者が本利用規約の規定に違反した場合",
    "RESTRICTION_MESSAGE_1_2": "二　なりすまし、サイバー攻撃、申請意思を欠く本サービスの利用若しくはその他不正に利用された場合又はそのおそれがあると本サービス提供者が認めた場合",
    "RESTRICTION_MESSAGE_1_3": "三　ウィルス等に感染している疑いのある端末からのアクセスを認めた場合",
    "RESTRICTION_MESSAGE_1_4": "四　前各号に掲げる場合のほか、本サービスの円滑な運営に支障を来し、又はそのおそれのある場合として本サービス提供者が必要であると認めた場合",
    "COPYRIGHTS": "第１４条（知的財産権）",
    "COPYRIGHTS_MESSAGE_1": "１　本サービスが利用者に対して提供するプログラムその他の著作物（本利用規約、利用者向けのマニュアル等を含みます。以下「コンテンツ等」といいます。）等の知的財産（知的財産基本法（平成 １４ 年法律第 １２２ 号）第２条第１項に定める「知的財産」をいいます。以下同じとします。）に関する特許権、商標権、著作権等の知的財産権（同法第２条第２項に定める「知的財産権」をいいます。）は、すべて本サービス提供者又は本サービス提供者に利用許諾をした第三者に帰属し、利用者に移転又は帰属しないものとします。",
    "COPYRIGHTS_MESSAGE_2": "２　利用者による本サービスの利用は、本サービス提供者の知的財産権の利用許諾を受けたことを意味するものではありません。",
    "COPYRIGHTS_MESSAGE_3": "３　利用者は、本サービスの利用に当たり、本サービス提供者が利用者に提供するコンテンツ等その他の著作物について、次の各号に掲げるとおり取り扱うものとします。",
    "COPYRIGHTS_MESSAGE_3_1": "一　本利用規約に従って本サービスを利用するためにのみ使用すること。ただし、本サービス提供者が本サービスの普及その他の理由により特に必要があると認めた場合には、利用者は本サービス提供者に利用を認められた範囲で使用することができる。",
    "COPYRIGHTS_MESSAGE_3_2": "二　複製、改変、編集、頒布等、不正なリバースエンジニアリングその他の著作権及び知的財産権を侵害する行為を行わないこと。",
    "COPYRIGHTS_MESSAGE_3_3": "三　営利目的の有無にかかわらず、第三者に貸与し、譲渡し、又は担保の設定をしないこと。",
    "COPYRIGHTS_MESSAGE_3_4": "四　利用者が、本サービスが利用者に対して提供するコンテンツ等を利用する際は、出典を記載すること。出典の記載方法は以下によるものとする。<br>（記載例）出典：「Ｊグランツ」（<a href='/'>http://www.jgrants-portal.go.jp</a>）",
    "COPYRIGHTS_MESSAGE_3_5": "五　コンテンツ等を編集・加工等して利用する場合は、上記に規定する出典とは別に、編集・加工等を行ったことを記載すること。なお、編集・加工等した情報を、あたかも国又は自治体が作成したかのような態様で公表又は利用しないこと。<br>（コンテンツを編集・加工等して利用する場合の記載例）出典：「Ｊグランツ」 （<a href='/'>http://www.jgrants-portal.go.jp</a>）をもとに○○株式会社作成 等）",
    "COPYRIGHTS_MESSAGE_3_6": "六　第三者が著作権を有しているコンテンツ等や、第三者が著作権以外の権利（例：写真における肖像権又はパブリシティ権等）を有しているコンテンツ等については、特に権利処理済であることが明示されているものを除き、利用者の責任で、当該第三者から利用の許諾を得ること。",
    "COPYRIGHTS_MESSAGE_3_7": "七　コンテンツ等において第三者が権利を有しているもののうち、出典の表記等によって第三者が権利を有していることを直接的又は間接的に表示又は示唆しているものを除いて、明確に第三者が権利を有している部分の特定・明示等を行っていないものについて利用する場合は、利用者の責任において第三者に権利があることを表示又は示唆している箇所を確認すること。",
    "COPYRIGHTS_MESSAGE_3_8": "八　デジタル庁が指定する者が表示した著作権表示若しくは商標表示を削除し、又は変更しないこと。",
    "AVAILABLE_TIME": "第１５条（利用可能時間及び利用の停止等）",
    "AVAILABLE_TIME_MESSAGE_1": "１　本サービスの利用可能時間は、原則として 24 時間 365 日とします。ただし、本サービス提供者は、利用可能時間における利用について努力義務を負うのみであり、利用できることを保証するものではありません。",
    "AVAILABLE_TIME_MESSAGE_2": "２　本サービス提供者は、次の各号のいずれかに該当すると認められる場合は、事前に本サービスに掲載する方法により利用者に周知して本サービスの利用の停止（一時停止を含みます。以下同じとします。）をすることができるものとします。ただし、緊急を要する場合には、掲載することなく、本サービスの利用の停止をすることができるものとします。",
    "AVAILABLE_TIME_MESSAGE_2_1": "一　本サービスに関する情報の提供元となる行政機関等のシステムの運営状況により、本サービスの運営が困難となった場合",
    "AVAILABLE_TIME_MESSAGE_2_2": "二　本サービスに係るハードウェア、ソフトウェア、通信機器その他関連する機器若しくはシステムの点検又は保守作業を定期的又は緊急的に行う場合",
    "AVAILABLE_TIME_MESSAGE_2_3": "三　本サービスに関するセキュリティ上の問題が生じた場合",
    "AVAILABLE_TIME_MESSAGE_2_4": "四　コンピュータ又は通信回線等の障害、誤操作、過度なアクセスの集中、不正アクセス、ハッキング、その他予期せぬ要因により本サービスの提供が困難となった場合",
    "AVAILABLE_TIME_MESSAGE_2_5": "五　天災地変、戦争、戦争のおそれ、封鎖、通商停止、革命、暴動、疫病その他の伝染病の流行、物資又は施設の破壊又は損傷、火災、台風、地震、洪水その他本サービス提供者の支配を超える事由が発生した場合",
    "AVAILABLE_TIME_MESSAGE_2_6": "六　法令等又はこれらに基づく措置により本サービスの運営が困難となった場合",
    "AVAILABLE_TIME_MESSAGE_2_7": "七　その他前各号に準じる事由により本サービス提供者が必要と判断した場合",
    "ENVIRONMENTAL_CONDITIONS": "第１６条（環境条件） ",
    "ENVIRONMENTAL_CONDITIONS_MESSAGE_1": "　利用者が本サービスを利用する際の環境条件は、デジタル庁ウェブサイトに掲載する条件とします。<br>【<a href='/faq'>https://www.jgrants-portal.go.jp/faq</a>　２．Jグランツの利用環境】",
    "EQUIPMENT": "第１７条（利用者の設備等）",
    "EQUIPMENT_MESSAGE_1": "１　利用者は、本サービスを利用するにあたり必要な機器等（スマートフォン、パソコン、ソフトウェア及びその他インターネット接続に必要な機器）を自らの負担で用意し、また、機器の準備に必要な手続きも自らの責任で行うものとします。",
    "EQUIPMENT_MESSAGE_2": "２　本サービスを利用するにあたり必要な費用（インターネットの通信費等）は、利用者が負担するものとします。",
    "SERVICE": "第１８条（本サービスの内容の変更・追加・終了）",
    "SERVICE_MESSAGE_1": "１　本サービス提供者は、本サービス提供者の都合により、本サービスの内容を変更又は追加できるものとします。ただし、本利用規約の変更を要する場合、本サービス提供者は、本サービスの内容の変更又は追加と併せて、第２３条（本利用規約の改定）に従い本利用規約の変更をするものとします。",
    "SERVICE_MESSAGE_2": "２　本サービス提供者は、利用者に事前に通知することにより、本サービスの提供を終了できるものとします。ただし、緊急の場合その他事前の通知が困難な場合には、事後に通知するものとします。",
    "BANKINFO": "第１９条（口座情報確認）",
    "BANKINFO_MESSAGE_1": "１　利用者が本サービスを利用した申請において、口座情報を入力する場合には、入力された口座情報の実在性を確認するため、本サービスから外部の口座確認サービスを通じ、金融機関に対して当該口座に関する情報を照会する処理を行います。",
    "BANKINFO_MESSAGE_2": "２　利用者は、補助金等受取口座の登録及び口座情報の管理に当たり、本サービス提供者に対し、補助金等受取口座として登録を受付けた又は登録されている預貯金口座の実在性を確認するため、本サービス提供者が外部の口座確認サービス等を通じて金融機関に対して当該口座に関する情報を照会する場合があることに同意します。",
    "BANKINFO_MESSAGE_3": "３　補助金等受取口座として登録できる口座情報は、利用者の名義の預貯金口座であることとします。",
    "BANKINFO_MESSAGE_4": "４　本サービス提供者は、本条第1項で確認した情報を利用して、補助金等受取口座の登録又は登録された口座情報の変更、口座情報の修正若しくは訂正若しくは口座情報の削除ができるものとします。",
    "BANKINFO_MESSAGE_5": "５　本サービス提供者は、前項に基づき登録された口座情報を修正若しくは訂正又は削除した場合、本サービス提供者が定める方法で利用者に通知するものとします。",
    "BANKINFO_MESSAGE_6": "６　本サービス提供者は、補助金等受取口座の登録を受付した後、預貯金口座の実在性を確認する等、口座情報の審査を行います。以下の場合、本サービス提供者は登録手続きを中止することがあります。",
    "BANKINFO_MESSAGE_6_1": "一　登録を受付けた内容に誤記、記入漏れ若しくは虚偽があることが発見された場合又はその疑いがある場合",
    "BANKINFO_MESSAGE_6_2": "二　口座情報確認の結果、登録する預貯金口座の実在性が確認できない場合",
    "PERSONA": "第２０条（個人情報等の取扱い）",
    "PERSONA_MESSAGE_1": "１　本サービスでは、利用者から取得する個人情報等について、法令及び別途に定めるプライバシーポリシー（<a href='/privacy-policy'>https://www.jgrants-portal.go.jp/privacy-policy</a>）に従い、これを取り扱うものとします。",
    "PERSONA_MESSAGE_2": "２　前項の規定は、本サービスがＧビズＩＤを通じて取得する利用者の情報について準用します。",
    "PERSONA_MESSAGE_3": "３　個人情報を含め登録された情報（第９条に定める各種通知にかかる情報を含みます。）は、利用者による補助金等申請に係る利便性向上、事務局による補助金等業務の品質向上、補助金等に係る会計検査又は監査等の業務に利用されるものとします。",
    "PERSONA_MESSAGE_4": "４　登録された情報は、官民データ活用推進基本法でのオープンデータ基本指針に基づき、①個人情報が含まれるもの、②国や公共の安全、秩序の維持に支障を及ぼすおそれがあるもの、③法人や個人の権利利益を害するおそれがあるもの等、公開することが適当ではない情報を除いたものをオープンデータの対象とします。",
    "DISCLAIMER": "第２１条（免責事項）",
    "DISCLAIMER_MESSAGE_1": "　本サービスの利用にあたり、利用者又は第三者が被った損害について、本サービス提供者（その運営を委託された外部事業者を含みます。以下本条において同じとします。）の故意又は重過失によるものである場合を除き、本サービス提供者は責任を負わないものとします。",
    "CONFIDENTIALITY": "第２２条（秘密保持）",
    "CONFIDENTIALITY_MESSAGE_1": "　利用者は、本サービスに関連して本サービス提供者が利用者に対して秘密に取扱うことを求めて開示した非公知の情報について、本サービス提供者の事前の書面による承諾がある場合を除き、秘密に取扱うものとします。",
    "REVISION": "第２３条（本利用規約の改定）",
    "REVISION_MESSAGE_1": "１　本サービス提供者は、次の各号のいずれかに該当する場合、本利用規約を改定することができるものとします。",
    "REVISION_MESSAGE_1_1": "一　本利用規約の変更が、利用者の一般の利益に適合するとき",
    "REVISION_MESSAGE_1_2": "二　本利用規約の変更が、登録をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更にかかる事情に照らして合理的なものであるとき",
    "REVISION_MESSAGE_2": "２　本サービス提供者は、前項に基づく本利用規約の改定を行う場合は、本利用規約を変更する旨、改定後の利用規約の内容及びその効力発生時期を事前にデジタル庁ウェブサイトに掲載する方法により利用者に通知するものとします。",
    "REVISION_MESSAGE_3": "３　法令上、利用者の同意が必要となるような内容の変更の場合は、本サービス提供者所定の方法で利用者の同意を得るものとします。",
    "CHARGE": "第２４条（利用料金）",
    "CHARGE_MESSAGE_1": "　本サービスの利用は無料とします。ただし、本サービスは、将来にわたって、利用料金の請求の権限を放棄するものではないものとします。",
    "SEPARABILITY": "第２５条（分離可能性）",
    "SEPARABILITY_MESSAGE_1": "　本利用規約のいずれかの条項又はその一部が、法令等により無効又は執行不能と判断された場合であっても、本利用規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。",
    "LANGUAGE": "第２６条（使用言語）",
    "LANGUAGE_MESSAGE_1": "　本サービスの利用に係る手続及び問合せ等は、日本語で行うものとします。",
    "OWNERSHIP": "第２７条（権利の帰属）",
    "OWNERSHIP_MESSAGE_1": "　本利用規約に規定する本サービス提供者が有する権利については、本サービス提供者がこれを行使しない場合においても、それによって本サービス提供者が当該権利を放棄するものではなく、当該権利は、なお本サービス提供者に帰属するものとします。",
    "LAW": "第２８条（準拠法及び裁判管轄）",
    "LAW_MESSAGE_1": "１　本利用規約は、日本法に準拠し解釈されるものとします。",
    "LAW_MESSAGE_2": "２　本利用規約及び本サービスに関連して利用者と本サービス提供者との間に生じたあらゆる紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。",
    "ETC": "第２９条（その他）",
    "ETC_MESSAGE_1": "１　本利用規約は、著作権法上認められている引用等の利用について、制限するものではありません。",
    "ETC_MESSAGE_2": "２　本利用規約は、２０２０年１２月２４日に定めたものです。本利用規約は、政府標準利用規約（第２.０版）に準拠しています。本利用規約は、今後変更される可能性があります。既に政府標準利用規約の以前の版に従ってコンテンツを利用している場合は、引き続きその条件が適用されます。",
    "ETC_MESSAGE_3": "３　本利用規約は、クリエイティブ・コモンズ・ライセンスの表示４.０国際（外部リンクに規定される著作権利用許諾条件。以下「CC BY」といいます。）と互換性があり、本利用規約が適用されるコンテンツはCC BYに従うことでも利用することができます。",
    "ETC_MESSAGE_4": "４　本サービス提供者は、利用者に対し、本サービスの利用状況等について、アンケートの実施その他の方法により聴取し、情報の提供を求めることができるものとします。この場合において、利用者は、可能な範囲で情報の提供の求めに応じるよう努めるものとします。",
    "ETC_MESSAGE_5": "５　当サイトへのリンクは、原則として自由です。ただし、リンク元サイトのコンテンツが（ア）公序良俗に反するもの（イ）法律若しくは法令等に違反し、又は違反するおそれがある内容を含むものと認められる場合には、リンクはお断りします。また、リンクの設定等が適当でないと判断される場合には、修正又はリンクの解除等を求める通知を行う場合がありますので、その場合には通知の内容に従い速やかに対応を求めるものとします。リンクを設定する際には以下のバナーもご利用いただけます。",
    "ETC_LINK": "リンク：<a href='/'>http://www.jgrants-portal.go.jp</a>",
    "ETC_BANNER": "バナー：<img src='assets/images/logo.svg' />",
    "SUPPLEMENT": "附則",
    "SUPPLEMENT_PUBLISHED": "（発行）",
    "SUPPLEMENT_PUBLISHED_MESSAGE_1": "本利用規約は、2020年12月24日から効力を有するものとします。"
  },
  "PRIVACY_POLICY": {
    "TITLE": "プライバシーポリシー",
    "TOP": "Ｊグランツ プライバシーポリシー",
    "BASIC_POLICY": "１．基本方針",
    "BASIC_POLICY_MESSAGE_1": "　Ｊグランツプライバシーポリシー（以下「本プライバシーポリシー」といいます。）は、補助金申請におけるＪグランツ（以下「本サービス」といいます。）の利用に関し、個人情報等の取扱いの基本方針を記載するものです。",
    "BASIC_POLICY_MESSAGE_2": "　デジタル庁（以下「本サービス提供者」といいます。）は、本サービスの円滑な運営に必要な範囲で、本サービスの利用者や事務局（以下総称して「利用者等」といいます。）の情報（２．（１）各号に記載の情報をいいます。以下同じです。）を取得します。取得した情報は、以下に定める利用目的の範囲内で適切に取り扱います。",
    "BASIC_POLICY_MESSAGE_3": "なお、本プライバシーポリシーにおける用語の定義は、特に定めのない限り、別途定める「Ｊグランツ利用規約」の定義によるものとします。",
    "RANGE_INFO_COLLECT": "２．取得する情報の範囲",
    "RANGE_INFO_COLLECT_MESSAGE_1": "（１）　本サービスでは、本サービス提供者は利用者等に係る以下の情報を取得します。なお、以下に該当する情報であっても、取得または保管の態様によっては、個人情報の保護に関する法律（平成十五年法律第五十七号）に定める個人情報に該当しないことがあります。",
    "RANGE_INFO_COLLECT_MESSAGE_1_1": "一　事業形態を法人として登録する場合には、法人番号、法人名（商号又は名称）、本店又は主たる事務所の所在地、代表者氏名（氏名については、フリガナを含みます。以下同じです。）及び当該者の生年月日",
    "RANGE_INFO_COLLECT_MESSAGE_1_2": "二　事業形態を個人事業主として登録する場合には、屋号、印鑑登録証明書に記載されている住所、代表者（個人事業主）氏名及び当該者の生年月日",
    "RANGE_INFO_COLLECT_MESSAGE_1_3": "三　売上高や自己資本、決算年月日などの財務状況に係る情報",
    "RANGE_INFO_COLLECT_MESSAGE_1_4": "四　利用者の氏名、生年月日、所属する部署等の名称、役職及び連絡先情報（住所及び郵便番号、電話番号並びにメールアドレス）",
    "RANGE_INFO_COLLECT_MESSAGE_1_5": "五　利用者が補助金等受取を希望する金融機関及び口座番号に関する情報",
    "RANGE_INFO_COLLECT_MESSAGE_1_6": "六　インターネットドメイン名、ＩＰアドレス、その他の閲覧等に係る情報。なお、クッキー（サーバ側で利用者等を識別するために、サーバから利用者等のブラウザに送信され、利用者等のコンピュータに蓄積される情報）は、ユーザビリティーの向上を目的とする内容に限定するものであり、個人情報は一切含みません。また、利用者等のブラウザの設定によりクッキーの機能を無効にすることもできます。",
    "RANGE_INFO_COLLECT_MESSAGE_1_7": "七　前各号に掲げるものの他、利用者による補助金の申請にあたり事務局が利用者に対して追加的に入力を求める情報",
    "RANGE_INFO_COLLECT_MESSAGE_1_8": "八　申請日時や申請先を含む補助金の申請履歴",
    "RANGE_INFO_COLLECT_MESSAGE_1_9": "九　本サービスに係るお問合せ等の内容",
    "RANGE_INFO_COLLECT_MESSAGE_2": "（２）　本サービスでは、下記の外部事業者のサービスを利用しています。外部事業者のサービスを利用するにあたって入力するデータは、各サービスを提供する外部サービス事業者によって取得されることがあります。取得される情報については、各事業者のプライバシーポリシーをご参照ください。",
    "RANGE_INFO_COLLECT_MESSAGE_2_1": "一　株式会社ユーザーローカルが提供するUser Insight（本サービスの利用状況を把握するため）<br>【株式会社ユーザーローカルのプライバシーポリシー（<a href='https://info.userlocal.jp/data_policy/'>株式会社ユーザーローカル</a>）】",
    "RANGE_INFO_COLLECT_MESSAGE_2_2": "二　株式会社L is Bが提供するチャットボット（本サービスの利便性向上のため）<br>【株式会社LisBのプライバシーポリシー（<a href='https://l-is-b.com/ja/privacy/'>プライバシーポリシー | 株式会社 L is B（エルイズビー）</a>）】",
    "PURPOSE_OF_USE": "３．利用目的",
    "PURPOSE_OF_USE_MESSAGE_1": "　本サービスで取得する利用者等の情報については、次の各号に掲げる目的のために利用するものとし、目的以外のために利用及び第三者への提供は行いません。",
    "PURPOSE_OF_USE_MESSAGE_2": "（１）　本サービスの安全かつ円滑な提供のため",
    "PURPOSE_OF_USE_MESSAGE_3": "（２）　利用者による補助金申請に係る利便性向上のため",
    "PURPOSE_OF_USE_MESSAGE_4": "（３）　事務局による補助金業務の品質向上のため",
    "PURPOSE_OF_USE_MESSAGE_5": "（４）　補助金に係る会計検査又は監査等の業務のため",
    "PURPOSE_OF_USE_MESSAGE_6": "（５）　口座情報確認にて補助金等受取口座の実在性確認等を行うため",
    "PURPOSE_OF_USE_MESSAGE_7": "（６）　利用者への本サービス利用に関する情報提供依頼（アンケート等）、統計データ生成のため",
    "PURPOSE_OF_USE_MESSAGE_8": "（７）　官民データ活用推進基本法でのオープンデータ基本指針に基づき、オープンデータの対象とするため（①個人情報が含まれるもの、②国や公共の安全、秩序の維持に支障を及ぼすおそれがあるもの、③法人や個人の権利利益を害するおそれがあるもの等、公開することが適当ではない情報を除きます）。",
    "PURPOSE_OF_USE_MESSAGE_9": "なお、利用者が申請した補助金に係る手続き、利用者への本サービス利用に関する情報提供依頼（アンケート等）、補助金に係る政策立案、計画作成、実績把握及び検査、監査、統計データ生成等のため、利用者の情報を事務局も取得します。関係府省等における情報の取扱いについては、それぞれの組織の責任において行われます。",
    "USAGE_RESTRICTIONS": "４．利用および提供の制限",
    "USAGE_RESTRICTIONS_MESSAGE_1": "　法令に基づく開示請求があった場合及び個人情報保護法第 69 条第 2 項各号該当事由がある場合を除き、取得した情報を目的以外のために自ら利用し、又は第三者に提供いたしません。",
    "AFTER_WITHDRAWAL_USER_HANDLING": "５．退会後の利用者の情報の取扱い",
    "AFTER_WITHDRAWAL_USER_HANDLING_MESSAGE_1": "　利用者が本サービスの利用を終了した場合、本サービス提供者は、遅滞なく当該利用者にかかるGビズIDアカウントの情報等の利用停止を行いますが、利用目的の達成に必要な場合、当該利用者の情報であっても継続して保持することがあります。",
    "ENSURING_SAFETY": "６. 安全確保の措置",
    "ENSURING_SAFETY_MESSAGE_1": "（１）　本サービスでは、利用者等の情報の漏えい、滅失又は毀損の防止その他利用者等の情報の適切な管理のために必要な措置を講じます。また、情報の取得及び送信に当たっては、ブラウザとウェブサーバとの間の通信について暗号化を行うことで、セキュリティを確保します。",
    "ENSURING_SAFETY_MESSAGE_2": "（２）　本サービスは、本サイトに係るシステム保守等の目的で、本サイトの運用を外部の第三者に委託することに伴い、また本プライバシーポリシーに記載する個人情報に係る問合せ対応等を外部の第三者に委託する場合、個人情報の取扱いについても当該第三者に委託する場合があります。その場合には、当該委託先においても取得した個人情報の漏えい、滅失又はき損の防止その他の取得した情報の適切な管理がなされるよう、必要な措置を講じます。",
    "ENSURING_SAFETY_MESSAGE_3": "（３）　２（２）に記載する外部事業者により取得された情報は、各事業者のプライバシーポリシーに基づいて管理されます。なお、当該外部事業者のサービス利用及びその責めにより生じた損害については、本サービス提供者（その運営を委託された外部事業者を含みます。）は責任を負わないものとします。",
    "SCOPE_OF_APPLICATION": "７．適用範囲",
    "SCOPE_OF_APPLICATION_MESSAGE_1": "　本プライバシーポリシーは、本サービスにのみ適用されます。",
    "SUSPENSION_PROCEDURE": "８．開示・訂正・利用停止請求手続き",
    "SUSPENSION_PROCEDURE_MESSAGE_1": "　本サービス提供者は、利用者本人又はその代理人からの開示、訂正、利用停止等の請求に対し、個人情報保護法その他の法令に基づき対処します。請求においては、以下のリンクから、所定の様式にて申請してください。",
    "SUSPENSION_PROCEDURE_LINK_1": "<a href='https://www.digital.go.jp/personal-information-protection'>個人情報保護｜デジタル庁 (digital.go.jp)</a>",
    "CONTACT_US": "９．お問合せ",
    "CONTACT_US_MESSAGE_1": "　本プライバシーポリシーについてのお問合せは、下記の宛先にお送りください。",
    "CONTACT_US_MESSAGE_2": "デジタル庁 Ｊグランツ担当",
    "CONTACT_US_LINK_1": "<a href='https://forms.office.com/pages/responsepage.aspx?id=_6DkBnJJi0qvMEVxNh0TRMtOMF5w6hFHrDJU_QHmk3NUMDdSM1ZSRldLVzRITU5GUEFLQ1hFRlhYOCQlQCN0PWcu&route=shorturl'>お問い合わせフォーム</a>",
    "PRIVACY_POLICY": "１０．プライバシーポリシーの改訂及びその方法",
    "PRIVACY_POLICY_MESSAGE_1": "　本プライバシーポリシーは適宜改訂されることがあります。改訂する場合は、別途定める本サービス利用規約所定の方法でお知らせします。",
    "ENACTMENT_DATE": "制定：2020年12月24日<br>改訂：2022年7月21日<br>改訂：2025年9月26日"
  },
  "OPENSOURCE_LICENSES": {
    "TITLE": "オープンソースライセンス"
  },
  "SIGNUP": {
    "TITLE": "ログイン",
    "LABEL_1": "Jグランツから補助金の申請を行うにはGビズIDの取得が必要です。あらかじめご用意をお願いします。",
    "LABEL_2": "■GビズIDとは、法人又は個人事業主の方が各種行政サービスを電子申請頂く際にご利用いただけるログインアカウントです。",
    "LABEL_3": "■Jグランツ利用可能なGビズIDの種別",
    "LABEL_4": "詳細を見る",
    "LABEL_5": "GビズIDプライム（法人等の代表者アカウント）",
    "LABEL_6": "GビズIDメンバー（組織の従業員用アカウントとしてプライムが許可したアカウント）",
    "LOGIN_GBIZID": "GビズIDでログインする",
    "CREATE_GBIZID": "GビズIDを取得する"
  },
  "COMPANY_INFO": {
    "TITLE": "自社情報の確認・編集",
    "BASIC_INFO": "GビズIDの登録内容",
    "GBIZ_SETTING": "登録内容を変更する場合は、<a href='https://gbiz-id.go.jp/top/'>GビズIDのウェブサイト</a>へ移動してください。",
    "BUSINESS_FORM": "事業形態",
    "CORPORATION": "法人",
    "COR_CORPORATE_NUMBER": "法人番号",
    "COR_NAME": "法人名",
    "COR_ADDRESS": "本社所在地",
    "COR_REP_NAME": "代表者名",
    "SOLE_PROPRIETOR": "個人事業主",
    "SOL_CORPORATE_NUMBER": "事業者識別番号",
    "SOL_NAME": "屋号",
    "SOL_ADDRESS": "印鑑登録証明書住所",
    "SOL_REP_NAME": "個人事業主氏名",
    "ADDITIONAL_INFO": "自社情報の管理",
    "ADDITIONAL_INFO_EDIT": "情報を登録すると、申請情報の入力時に自動で反映されます。",
    "COR_EDIT_CORPORATE_TYPE_DETAIL": "法人事業形態詳細",
    "COR_EDIT_CORPORATE_TYPE_PRIVATE": "民間",
    "COR_EDIT_CORPORATE_TYPE_CENTRAL": "中央省庁",
    "COR_EDIT_CORPORATE_TYPE_MUNICIPALITY": "自治体",
    "COR_EDIT_NAME_KANA": "法人名（カナ）",
    "COR_EDIT_REPRESENTATIVE_POST": "代表者役職",
    "COR_EDIT_BUSINESS_DESCRIPTION": "法人の営む主な事業及びその内容",
    "COR_EDIT_FOUNDATION_DATE": "設立年月日（法人）",
    "COR_EDIT_BUSINESS_SCALE": "事業規模",
    "COR_EDIT_BUSINESS_SCALE_MEDIUM": "中小企業",
    "COR_EDIT_BUSINESS_SCALE_SMALL": "小規模企業",
    "COR_EDIT_BUSINESS_SCALE_OTHER": "その他",
    "COR_EDIT_EMPLOYEES_NUMBER": "従業員数",
    "COR_EDIT_CATERGORY": "法人の営む主な事業（業種：大分類）",
    "COR_EDIT_SUBCATERGORY": "法人の営む主な事業（業種：中分類）",
    "COR_EDIT_FURTHER_SUBCATEGORY": "法人の営む主な事業（業種：小分類）",
    "COR_EDIT_CAPITAL_STOCK": "資本金（出資金）（単位：円）",
    "SOL_EDIT_NAME_KANA": "屋号（カナ）",
    "SOL_EDIT_REPRESENTATIVE_POST": "個人事業主役職",
    "SOL_EDIT_BUSINESS_DESCRIPTION": "個人事業主の営む主な事業及びその内容",
    "SOL_EDIT_FOUNDATION_DATE": "設立年月日（個人事業主）",
    "SOL_EDIT_CATERGORY": "個人事業主の営む主な事業（業種：大分類）",
    "SOL_EDIT_SUBCATERGORY": "個人事業主の営む主な事業（業種：中分類）",
    "SOL_EDIT_FURTHER_SUBCATEGORY": "個人事業主の営む主な事業（業種：小分類）",
    "COR_EDIT_CLOSING_DATE": "決算年月日",
    "COR_EDIT_TOTAL_CURRENT_ASSETS": "流動資産（単位：円）",
    "COR_EDIT_TOTAL_CURRENT_LIABILITIES": "流動負債（単位：円）",
    "COR_EDIT_TOTAL_NET_ASSETS": "自己資本（単位：円）",
    "COR_EDIT_TOTAL_ASSETS": "総資本（単位：円）",
    "COR_EDIT_AMOUNT_OF_SALES": "売上高（単位：円）",
    "COR_EDIT_COST_OF_SALES": "原価（単位：円）",
    "COR_EDIT_TOTAL_CURRENT_ASSETS_RATIO": "流動比率",
    "COR_EDIT_TOTAL_NET_ASSETS_RATIO": "自己資本比率",
    "COR_EDIT_GROSS_PROFIT": "粗利益",
    "COR_EDIT_LABOR_PRODUCTIVITY": "労働生産性",
    "SOL_EDIT_EMPLOYEES_NUMBER": "従業員数",
    "SOL_EDIT_CLOSING_DATE": "決算年月日",
    "SOL_EDIT_TOTAL_CURRENT_ASSETS": "流動資産（単位：円）",
    "SOL_EDIT_TOTAL_CURRENT_LIABILITIES": "流動負債（単位：円）",
    "SOL_EDIT_TOTAL_NET_ASSETS": "自己資本（単位：円）",
    "SOL_EDIT_TOTAL_ASSETS": "総資本（単位：円）",
    "SOL_EDIT_AMOUNT_OF_SALES": "売上高（単位：円）",
    "SOL_EDIT_COST_OF_SALES": "原価（単位：円）",
    "SOL_EDIT_TOTAL_CURRENT_ASSETS_RATIO": "流動比率",
    "SOL_EDIT_TOTAL_NET_ASSETS_RATIO": "自己資本比率",
    "SOL_EDIT_GROSS_PROFIT": "粗利益",
    "SOL_EDIT_LABOR_PRODUCTIVITY": "労働生産性"
  },
  "DELEGATE_ACCOUNT_INFO": {
    "COR_SOL_DELEGATOR_NAME": "委任元担当者（委任者）氏名",
    "COR_SOL_CORPORATE_NUMBER": "法人番号/個人事業主番号",
    "COR_SOL_NAME": "法人名/屋号",
    "COR_SOL_REP_NAME": "代表者氏名/個人事業主名",
    "COR_SOL_ADDRESS": "本店所在地/印鑑登録証明書住所",
    "DELEGATION_CONTENT": "委任内容",
    "SELECT": "選択",
    "DELEGATION_LIST_TITLE": "代理申請の受任一覧"
  },
  "DELEGATE_ACCOUNT_SEARCH": {
    "SEARCH_TITLE": "委任元事業者を検索",
    "DELEGATOR_NAME": "委任元事業者名（法人名/屋号）",
    "CORPORATE_NUMBER": "法人番号/個人事業主番号",
    "REP_NAME": "代表者氏名/個人事業主名",
    "ADDRESS": "本店所在地/印鑑登録証明書住所"
  },
  "DELEGATION_INFO": {
    "DELEGATION_APPLICATION_INFO": "代理申請情報",
    "DELEGATION_APPLICANT_INFO": "代理申請者情報",
    "DELEGATION_START_DATE": "委任期間開始日",
    "DELEGATION_END_DATE": "委任期間終了日",
    "APPROVAL_REQUEST_DATE": "代理申請の確認依頼日",
    "APPROVAL_REQUESTER": "確認依頼者",
    "APPROVAL_REQUESTER_EMAIL": "確認依頼者メールアドレス",
    "DELEGATION_APPLICANT": "代理申請者",
    "DELEGATION_APPLICANT_EMAIL": "代理申請者メールアドレス",
    "DELEGATION_STATUS": "代理申請のステータス",
    "DELEGATION_NO": "委任関係ID",
    "SELECT_DELEGATION_NO": "委任関係IDの選択"
  },
  "DELEGATION_HISTORY": {
    "DELEGATION_INFO": "操作履歴",
    "DELEGATION_HISTORY": "操作日時",
    "DELEGATION_OPERATOR": "操作者",
    "DELEGATION_ACTION": "アクション"
  },
  "DELEGATION_NO_SELECT": {
    "ACTION": "操作",
    "DELEGATION_NO": "委任関係ID",
    "DELEGATION_PERIOD": "委任期間",
    "DELEGATION_CONTENT": "委任内容",
    "NOTE": "備考",
    "SHOW_ALL": "全て表示",
    "NO_CATEGORY": "全ての制度"
  },
  "PROJECT_INFO": {
    "PROJECT_NAME": "事業の名称",
    "START_DATE_DETERMINE_METHOD": "事業開始日の決定方法",
    "START_DATE_AT_REQUEST": "事業開始日（公募・交付申請時）",
    "END_DATE_AT_REQUEST": "事業終了日（公募・交付申請時）",
    "REQUIRED_EXPENSES_TOTAL": "補助事業に要する経費（合計）",
    "GRANT_REQUEST_AMOUNT_TOTAL": "補助金交付申請額（合計）",
    "TARGET_EXPENSES_TOTAL": "補助対象経費（合計）",
    "DETERMINE_METHOD_OPTION1": "交付決定日から開始",
    "DETERMINE_METHOD_OPTION2": "指定日から開始",
    "DETERMINE_METHOD_OPTION3": "事業終了日と同日",
    "START_DATE_HINT": "「指定日から開始」以外を選択した場合、「事業開始日」の値は無効となります。"
  },
  "REQUEST_FORM": {
    "TITLE": "申請",
    "REQUEST_INFO": "申請先情報",
    "REQUEST_NUMBER": "申請番号",
    "SUBSIDY_NAME": "補助金名",
    "REQUEST_FORM_NAME": "申請フォーム名",
    "REMAND_COMMENT": "差戻し／棄却コメント",
    "PAST_REMAND_COMMENT": "前回までの差戻し/棄却コメント",
    "NO_REJECT_COMMENT": "コメントなし"
  },
  "SUBSIDY_LIST": {
    "TITLE": "補助金を探す",
    "SUB_TITLE": "検索",
    "FILTER_TITLE_SEARCH": "条件から探す",
    "FILTER_TITLE_THEME": "テーマから探す",
    "SEARCH_WITH_KEYWORD": "キーワードを入れてください",
    "ACCEPTANCE_FILTER_DESCRIPTION_PLANNED": "募集予定の補助金",
    "ACCEPTANCE_FILTER_DESCRIPTION": "募集中の補助金",
    "ACCEPTANCE_FILTER_DESCRIPTION_CLOSED": "募集終了の補助金",
    "CAN_DELEGATION_FILTER_DESCRIPTION": "当サイトで代理申請可能な補助金のみ",
    "SEARCH_KEYWORD_HINT": "例：持続化、コロナ、販路開拓",
    "SEARCH_WITH_GOVERNMENT_TYPE": "補助金の所管",
    "SEARCH_WITH_SUPPORT": "利用目的",
    "SEARCH_WITH_FIELD": "関心のある分野",
    "SEARCH_WITH_INDUSTRY": "業種",
    "SEARCH_WITH_TARGET_NUMBER_OF_EMPLYEES": "従業員数の上限",
    "SEARCH_WITH_TARGET_AREA_SEARCH": "対象地域",
    "SEARCH_WITH_USE_PURPOSE": "利用目的",
    "SUBSIDY_NAME": "補助金名",
    "TARGET_AREA_SEARCH": "対象地域",
    "SUBSIDY_MAX_LIMIT": "補助上限額",
    "TARGET_NUMBER_OF_EMPLYEES": "従業員数の上限",
    "SUBSIDY_YEAR": "年度(年)",
    "ACCEPTANCE_DATE_TIME": "募集期間",
    "CAN_DEL_APPLY_LABEL": "代理申請可",
    "DELEGATION": "制度名",
    "GRANT_TYPE": "類型",
    "PRECAUTIONS": "注意事項",
    "SUBSIDY_OPTIONS": {
      "USE_PURPOSE": [
        {
          "value": "新たな事業を行いたい"
        },
        {
          "value": "販路拡大・海外展開をしたい"
        },
                {
          "value": "事業を引き継ぎたい"
        },
        {
          "value": "研究開発・実証事業を行いたい"
        },
        {
          "value": "人材育成を行いたい"
        },
        {
          "value": "資金繰りを改善したい"
        },
        {
          "value": "設備整備・IT導入をしたい"
        },
        {
          "value": "雇用・職場環境を改善したい"
        },
        {
          "value": "イベント・事業運営支援がほしい"
        },
        {
          "value": "エコ・SDGs活動支援がほしい"
        },
        {
          "value": "災害（自然災害、感染症等）支援がほしい"
        },
        {
          "value": "教育・子育て・少子化支援がほしい"
        },
        {
          "value": "スポーツ・文化支援がほしい"
        },
        {
          "value": "安全・防災対策支援がほしい"
        },
        {
          "value": "まちづくり・地域振興支援がほしい"
        }
      ],
      "INDUSTRY": [
        {
          "value": "農業、林業"
        },
        {
          "value": "漁業"
        },
        {
          "value": "鉱業、採石業、砂利採取業"
        },
        {
          "value": "建設業"
        },
        {
          "value": "製造業"
        },
        {
          "value": "電気・ガス・熱供給・水道業"
        },
        {
          "value": "情報通信業"
        },
        {
          "value": "運輸業、郵便業"
        },
        {
          "value": "卸売業、小売業"
        },
        {
          "value": "金融業、保険業"
        },
        {
          "value": "不動産業、物品賃貸業"
        },
        {
          "value": "学術研究、専門・技術サービス業"
        },
        {
          "value": "宿泊業、飲食サービス業"
        },
        {
          "value": "生活関連サービス業、娯楽業"
        },
        {
          "value": "教育、学習支援業"
        },
        {
          "value": "医療、福祉"
        },
        {
          "value": "複合サービス事業"
        },
        {
          "value": "サービス業（他に分類されないもの）"
        },
        {
          "value": "公務（他に分類されるものを除く）"
        },
        {
          "value": "分類不能の産業"
        }
      ],
      "TARGET_NUMBER_OF_EMPLYEES": [
        {
          "value": "従業員数の制約なし"
        },
        {
          "value": "5名以下"
        },
        {
          "value": "20名以下"
        },
        {
          "value": "50名以下"
        },
        {
          "value": "100名以下"
        },
        {
          "value": "300名以下"
        },
        {
          "value": "900名以下"
        },
        {
          "value": "901名以上"
        }
      ],
      "TARGET_AREA_SEARCH": [
        {
          "value": "全国"
        },
        {
          "value": "北海道"
        },
        {
          "value": "青森県"
        },
        {
          "value": "岩手県"
        },
        {
          "value": "宮城県"
        },
        {
          "value": "秋田県"
        },
        {
          "value": "山形県"
        },
        {
          "value": "福島県"
        },
        {
          "value": "茨城県"
        },
        {
          "value": "栃木県"
        },
        {
          "value": "群馬県"
        },
        {
          "value": "埼玉県"
        },
        {
          "value": "千葉県"
        },
        {
          "value": "東京都"
        },
        {
          "value": "神奈川県"
        },
        {
          "value": "新潟県"
        },
        {
          "value": "山梨県"
        },
        {
          "value": "長野県"
        },
        {
          "value": "富山県"
        },
        {
          "value": "石川県"
        },
        {
          "value": "福井県"
        },
        {
          "value": "岐阜県"
        },
        {
          "value": "静岡県"
        },
        {
          "value": "愛知県"
        },
        {
          "value": "三重県"
        },
        {
          "value": "滋賀県"
        },
        {
          "value": "京都府"
        },
        {
          "value": "大阪府"
        },
        {
          "value": "兵庫県"
        },
        {
          "value": "奈良県"
        },
        {
          "value": "和歌山県"
        },
        {
          "value": "鳥取県"
        },
        {
          "value": "島根県"
        },
        {
          "value": "岡山県"
        },
        {
          "value": "広島県"
        },
        {
          "value": "山口県"
        },
        {
          "value": "徳島県"
        },
        {
          "value": "香川県"
        },
        {
          "value": "愛媛県"
        },
        {
          "value": "高知県"
        },
        {
          "value": "福岡県"
        },
        {
          "value": "佐賀県"
        },
        {
          "value": "長崎県"
        },
        {
          "value": "熊本県"
        },
        {
          "value": "大分県"
        },
        {
          "value": "宮崎県"
        },
        {
          "value": "鹿児島県"
        },
        {
          "value": "沖縄県"
        },
        {
          "value": "海外"
        }
      ],
      "CAN_DELEGATION": [
        {
          "value": 0,
          "label": "すべて"
        },
        {
          "value": 1,
          "label": "可"
        },
        {
          "value": 2,
          "label": "不可"
        }
      ],
      "SORT_OPTIONS":[
        {
          "value": "募集終了日：近い順"
        },
        {
          "value": "募集終了日：遠い順"
        },
        {
          "value": "募集開始日：近い順"
        },
        {
          "value": "補助上限額：高い順"
        },
        {
          "value": "従業員数の上限：多い順"
        }
      ]
    }
  },
  "SUBSIDY_DETAIL": {
    "TITLE": "補助金詳細",
    "OUTLINE": "概要",
    "CONDITION": "条件",
    "PARTICULAR": "詳細",
    "SUBSIDY_INSTITUTION": "制度名",
    "SUBSIDY_CATCHPHRASE": "補助金のキャッチコピー",
    "DETAIL": "補助金のサマリー",
    "USE_PURPOSE": "利用目的",
    "INDUSTRY": "業種",
    "GRANT_TYPE": "類型",
    "TARGET_AREA_SEARCH": "補助対象地域",
    "TARGET_AREA": "補助対象地域詳細",
    "TARGET_NUMBER_OF_EMPLOYEES": "従業員数の上限",
    "SUBSIDY_RATE": "補助率",
    "SUBSIDY_MAX_LIMIT": "補助上限額",
    "ACCEPTANCE_START_DATETIME": "募集開始日時",
    "ACCEPTANCE_END_DATETIME": "募集終了日時",
    "PROJECT_END_DEADLINE": "事業終了期限",
    "PUBLIC_OFFERING_SUMMARY": "公募要領",
    "ISSUE_OUTLINE": "交付要綱",
    "APPLICATION_FORM": "申請様式",
    "PROXY_APPLICATION": "当サイトの代理申請",
    "CAN_PROXY_APPLICATION": "可",
    "CANNOT_PROXY_APPLICATION": "不可",
    "CANNOT_PROXY_APPLICATION_MESSAGE_1": "この補助金は代理申請が許可されていません",
    "SYSTEM": "制度名",
    "CANNOT_PROXY_APPLICATION_MESSAGE": "当サイトの代理申請不可",
    "BEFORE_PERIOD": "募集開始前",
    "AFTER_PERIOD": "募集終了",
    "NO_DEADLINE": "期限なし",
    "T_REQUEST_FORM_NAME": "申請フォーム名",
    "T_FISCAL_YEAR_ROUND": "募集名",
    "T_TARGET_AREA": "対象地域",
    "T_TARGET_AREA_DETAIL": "対象地域詳細",
    "T_PUBLIC_DATE": "募集期間",
    "T_PROJECT_END_DEADLINE": "事業終了期限",
    "T_ACTION": "アクション"
  },
  "REQUEST_PROJECT_LIST": {
    "TITLE": "マイページ",
    "TITLE_ON_DELEGATION": "委任元事業一覧",
    "PROJECT_PAGE_TITLE": "申請した事業を検索",
    "PANEL_OPEN_LABEL": "詳細な検索条件を開く",
    "PANEL_CLOSE_LABEL": "詳細な検索条件を閉じる",
    "REQUEST_HISTORY": "申請履歴",
    "PROJECT_NAME_CONDITION": "事業名",
    "PROCEDURE_CONDITION": "手続き名",
    "SUBSIDY_CONDITION": "補助金名",
    "PROJECT_NAME": "事業",
    "PROJECT_START_DATE": "事業開始日",
    "PROJECT_END_DATE": "事業終了日",
    "REQUEST_COMPLETE_DATETIME": "直近の申請日",
    "PROCEDURE": "手続き",
    "SUBSIDY": "補助金",
    "NO_TITLE": "（タイトルなし）",
    "DELEGATE": "代理申請",
    "ONLY_DELEGATION_PROJECTS": "代理で作成された申請のみ表示",
    "APPLY": "要確認",
    "LABEL_TITLE": "確認が必要な申請があります",
    "LABEL_SUBTITLE": "と記載されている申請をご確認ください。"
  },
  "REQUEST_DELEGATION_LIST": {
    "TITLE": "代理申請一覧",
    "DELEGATOR_LIST": "委任元一覧",
    "IS_PROXY_LOGIN": "代理操作中",
    "PROJECT_PAGE_TITLE": "申請した事業を検索",
    "PANEL_OPEN_LABEL": "詳細な検索条件を開く",
    "PANEL_CLOSE_LABEL": "詳細な検索条件を閉じる",
    "REQUEST_HISTORY": "代理申請履歴",
    "APPLY": "申請",
    "INVITATION": "公募",
    "STATUS": "ステータス",
    "REQUEST_CONDITION": "申請種類名（例：公募申請）",
    "STATUS_CONDITION": "ステータス",
    "REQUEST_DELEGATION_PAGE_TITLE": "代理申請した申請を検索",
    "DELEGATION_LIST": "委任元一覧",
    "DELEGATE_ACCOUNT_NAME_CONDITION": "委任元事業者名",
    "SUBSIDY_CONDITION": "補助金名",
    "DELEGATION_CREATED_DATE_FROM_CONDITION": "代理申請作成開始日",
    "DELEGATION_CREATED_DATE_TO_CONDITION": "代理申請作成終了日",
    "DELEGATION_APPROVAL_DATE_FROM_CONDITION": "代理申請確認日（開始）",
    "DELEGATION_APPROVAL_DATE_TO_CONDITION": "代理申請確認日（終了）",
    "DELEGATE_ACCOUNT_NAME": "委任元事業者名",
    "SUBSIDY": "補助金",
    "NO_TITLE": "（タイトルなし）",
    "DELEGATION_CREATION_DATE": "代理申請作成日",
    "REQUEST": "申請種類名",
    "DELEGATION_CREATED_DATE": "代理申請作成日",
    "DELEGATION_APPROVAL_DATE": "代理申請確認日",
    "CANNON_SELECT_MESSAGE_1": "この委任元は選択できません",
    "CANNON_SELECT_MESSAGE_2": "委任元事業者にGビズIDの発行と委任関係の設定を依頼してください",
    "DELEGATION_LIST_OPTIONS": {
      "DELEGATION_STATUS": [
        {
          "value": "代理申請下書き"
        },
        {
          "value": "委任元確認済み"
        },
        {
          "value": "委任元確認中"
        },
        {
          "value": "委任元編集中"
        },
        {
          "value": "代理申請訂正依頼中"
        },
        {
          "value": "委任元取り下げ"
        },
        {
          "value": "採択通知済み"
        },
        {
          "value": "不採択通知済み"
        },
        {
          "value": "通知済み"
        },
        {
          "value": "棄却済み"
        }
      ]
    }
  },
  "REQUEST_PROJECT_DETAIL": {
    "TITLE": "事業の詳細",
    "ENABLE_REQUEST": "提出可能な申請",
    "ENABLE_REQUEST_INFO": "提出可能な申請がある場合は、こちらに表示されます。",
    "NOTIFICATION_DOC": "通知文書（文面）",
    "NOTIFICATION_DOC_FILE": "通知文書添付ファイル",
    "NOTIFICATION_DOC_LINK": "文面表示",
    "PROJECT_NAME": "事業",
    "PROJECT_OFFICE_NAME": "事業所",
    "PROCEDURE": "手続き",
    "REQUEST_COMPLETE_DATETIME": "申請完了日時",
    "REQUEST_FORM_LIST": "作成済みの申請",
    "REQUEST_FORM_LIST_NOTE": "※下書き中の申請は下表のリンクから申請してください。",
    "REQUEST_FORM_NAME": "申請",
    "REQUEST_NUMBER": "申請番号",
    "REQUEST_STATUS": "申請状況",
    "SUBSIDY": "補助金",
    "PROJECT_INFO": "事業情報",
    "PROJECT_START_DATE": "事業開始日",
    "PROJECT_END_DATE": "事業終了日（予定）",
    "ACHIEVEMENT_PROJECT_END_DATE": "事業終了日（実績）",
    "REQUIRED_INSTRUCTION": "要求・命令",
    "REQUIRED_STATUS": "状態",
    "REQUIRED_INSTRUCTION_LIST": "要求・命令一覧",
    "NOTIFICATION_DATETIME": "通知日時",
    "AMOUNT_INFO": "金額情報",
    "ENABLE_AMOUNT_INFO": "金額確定に係る申請が確定した時に更新されます。ただし公募採択時点では未確定情報となります",
    "DECIDED_SUBSIDY_GRANT_AMOUNT": "補助金交付決定額",
    "PRELIMINARY_AMOUNT": "概算払済額計",
    "SUBSIDY_FIXED_AMOUNT": "補助金確定額",
    "DELETE_DRAFT": "下書き削除",
    "NOT_ASSIGNED_DELEGATION": "代理申請者は未割当です。"
  },
  "CONSULT": {
    "CONTENT_LABEL": "お問合せ内容",
    "ANSWER_LABEL": "回答内容",
    "CONSULT": "お問合せ",
    "ANSWER": "事務局からの回答"
  },
  "CONSULT_FORM": {
    "TITLE": "新規お問合せ",
    "SUBSIDY_NAME": "補助金名",
    "PROJECT_NAME": "事業名",
    "REQUEST_FORM_NAME": "申請フォーム名",
    "REQUEST_NUMBER": "申請番号",
    "REQUEST_INFO": "お問合せ管理情報",
    "BASIC_INFO": "事業者基本情報",
    "CORPORATE_NAME": "法人名/屋号",
    "CORPORATE_NAME_KANA": "法人名/屋号（カナ）",
    "LAST_NAME": "お問合せ者氏名（姓）",
    "FIRST_NAME": "お問合せ者氏名（名）",
    "PHONE_NUMBER": "電話番号",
    "EMAIL_ADDRESS": "E-mail アドレス",
    "REMAND_COMMENT": "差戻し／棄却コメント",
    "CONTENT_AREA": "問合せ内容",
    "CONTENT_LABEL": "お問合せ内容を入力してください。",
    "CONSULT": "お問合せ"
  },
  "CONSULT_LIST": {
    "TITLE": "お問合せ一覧",
    "KEYWORD": "キーワード",
    "SEARCH": "検索",
    "SUBSIDY_NAME": "補助金名",
    "PROJECT_NAME": "事業名",
    "REQUEST_FORM": "申請フォーム名",
    "REQUEST_NUMBER": "申請番号",
    "STATUS": "ステータス",
    "CREATED_DATE": "問合せ日時",
    "NUMBER": "NO",
    "CONTENT": "内容",
    "ONLY_NOT_ANSWERED": "未回答のみ",
    "SEARCH_FROM_DATE": "問合せ日From",
    "SEARCH_TO_DATE": "問合せ日To",
    "STATUS_OPTIONS": ["下書き", "未回答", "回答済み"]
  },
  "CONSULT_DETAIL": {
    "TITLE": "お問合せ詳細",
    "NUMBER": "お問合せ番号",
    "SUBSIDY_NAME": "補助金名",
    "PROJECT_NAME": "事業名",
    "REQUEST_FORM_NAME": "申請フォーム名",
    "REQUEST_NUMBER": "申請番号",
    "REQUEST_INFO": "お問合せ管理情報",
    "STATUS": "ステータス",
    "NEW_CONSULT": "追加お問合せ",
    "CONTENT_LABEL": "お問合せ内容を入力してください。",
    "REMAND_COMMENT": "差戻し／棄却コメント",
    "SHOW_MORE": "さらに過去の問合せを表示する",
    "CONSULT_PERSON_NAME": "お問合せ者氏名",
    "PHONE_NUMBER": "電話番号",
    "EMAIL_ADDRESS": "E-mail アドレス"
  },
  "FREQUENTLY_ASKED_QUESTION": {
    "TITLE_SUBSIDY": "この補助金に関するよくあるお問合せ",
    "TITLE_PROJECT": "申請した補助金に関するよくあるお問合せ"
  },
  "ATTACHMENT": {
    "TITLE": "添付ファイル"
  },
  "MODIFY_REQUEST": {
    "UNCHANGED_LABEL": "[修正依頼あり]",
    "CHANGED_LABEL": "[修正済]",
    "MODIFY_REQUEST_COMMENT_LABEL": "[修正依頼内容]",
    "UNCHANGED_ITEM": "未対応の修正依頼項目が残っています。"
  },
  "MESSAGE": {
    "DEFAULT_ERROR": "システムエラーが発生しました。もう一度はじめから操作をお願いいたします。",
    "INTERNAL_SERVER_ERROR": "サーバーエラーが発生しました。",
    "NOT_FOUND": "指定されたURLは存在しません。",
    "TOKEN_IS_EXPIRED": "セッションの有効時間が経過しました。再ログインが必要です。",
    "IE_WARNING": "Jグランツの動作環境は以下のとおりです。\n下記のブラウザの最新バージョンをご利用ください。\nなお、InternetExplorer等の下記以外のブラウザは、\n申請上のエラー等が生じますので利用しないでください。\n\n・Windows：chrome、firefox、edge(※1)\n・macOS：chrome、firefox、safari\n・Android：chrome\n\n※1 edgeの「InternetExplorerモード」は\n申請上のエラー等が生じますので利用しないでください。",
    "I_PG_0001": "データが見つかりません。",
    "I-PG-0002": "保存しました。",
    "I-PG-0003": "「申請する」ボタンを押した後は、申請内容を編集できません。\n入力内容に誤りが無いことを確認し、申請してください。",
    "I-PG-0004": "申請を事務局に提出しました。申請日時：{formInputDataSystemModStamp}",
    "I-PG-0005": "一時保存しました。",
    "I-PG-0006": "一時保存していない入力内容は失われます。",
    "I-PG-0007": "OKボタンを押すことで、画面上の下記の項目がミラサポplusからの情報で置き換わりますがよろしいですか？\n（代表者役職、設立年月日、決算年月日、流動資産、流動負債、自己資本、総資本、売上高、原価）\n\n※OKボタンを押すだけでは、まだミラサポplusから連携された情報で登録を行っていません。事業者情報画面の保存するボタンを押すことで登録が行われます。",
    "I-PG-0008": "OKボタンを押すことで、画面上の下記の項目がミラサポplusからの情報で置き換わりますがよろしいですか？\n（個人事業主役職、設立年月日、決算年月日、流動資産、流動負債、自己資本、総資本、売上高、原価）\n\n※OKボタンを押すだけでは、まだミラサポplusから連携された情報で登録を行っていません。事業者情報画面の保存するボタンを押すことで登録が行われます。",
    "I-PG-0009": "連携可能な項目がありませんでした",
    "I-PG-0010": "エラーが発生しました。ヘルプデスクにお問い合わせください。エラーコード:",
    "I-PG-0011": "この操作は取り消しができません。削除してよろしいですか？\nなお事業に紐づく作成済みの申請が全て削除された場合、申請事業も削除されます。",
    "I-PG-0012": "削除しました。",
    "I-PG-0013": "問合せをします。よろしいですか？",
    "I-PG-0014": "問合せを下書き保存します。よろしいですか？",
    "I-PG-0015": "問合せを事務局に提出しました。問合せ日時：",
    "I-PG-0016": "問合せを下書き保存しました。",
    "I-PG-0017": "追加の問合せをします。よろしいですか？",
    "I-PG-0018": "問合せを追加しました。問合せ日時：",
    "I-PG-0019": "下書き保存していない入力内容は失われます。",
    "I-PG-0020": "委任元から訂正依頼が無い限り、申請内容の編集はできません。\n内容に誤りがないか十分ご確認ください。",
    "I-PG-0021": "委任元へ確認依頼を送信しました。委任元事業者の確認をお待ち下さい。",
    "I-PG-0022": "「申請する」ボタンを押した後は、申請内容を編集できません。\n入力内容に誤りが無いことを確認し、申請してください。",
    "I-PG-0023": "申請を事務局に提出しました。申請日時：{formInputDataSystemModStamp}",
    "I-PG-0024": "代理申請者が訂正できるようにしますか？",
    "I-PG-0025": "代理申請者に訂正依頼を送信しました。代理申請者の確認依頼をお待ちください。",
    "I-PG-0026": "取り下げを実行しますか？",
    "I-PG-0027": "申請を取り下げました。",
    "I-PG-0029": "別の代理申請者に編集権限を引き渡しました。\n通知メールは送信されないため、代理申請の依頼を代理申請者へ別途連絡してください。",
    "I-PG-0030": "※この操作により委任元は一時的に編集不可となり、一時保存していない内容は失われます。\n※通知メールは送信されないため、代理申請の依頼を代理申請者へ別途連絡してください。",
    "I-PG-0031": "代理申請者に編集権限を引き渡しました。\n通知メールは送信されないため、代理申請の依頼を代理申請者へ別途連絡してください。",
    "I-PG-0032": "編集可能になりました。",
    "I-PG-0033": "別の代理申請者に編集権限を引き渡しますか？\nGビズIDにて代理申請者と委任関係を結んでいることを確認のうえ実施してください。\n委任関係がない場合はキャンセルを押してください。",
    "I-PG-0034": "別の代理申請者が編集できるようにしますか？\nGビズIDにて代理申請者と委任関係を結んだ場合にのみ実施することができます。\n委任関係がない場合は編集に戻るを押してください。",
    "I-PG-0035": "※この操作により、委任元へ確認依頼メールが送信されます。",
    "I-PG-0036": "※この操作により委任元は一時的に編集不可となり、一時保存していない内容は失われます。\n※実行時には代理申請者にメールで通知されます。",
    "I-PG-0037": "※この操作は取り消せません。また、一時保存していない内容は失われます。\n※実行時には代理申請者にメールで通知されます。",
    "I-PG-0038": "※この操作により代理申請者に編集権限が引き渡され、編集不可となります。\n※通知メールは送信されないため、代理申請の依頼を代理申請者へ別途連絡してください。",
    "I-PG-0039": "代理申請者に編集権限を引き渡しますか？\nGビズIDにて代理申請者と委任関係を結んでいることを確認のうえ実施してください。\n委任関係がない場合はキャンセルを押してください。",
    "I-PG-0040": "募集期間は、補助金内の複数ある申請手続きのうち、最も早い募集開始日・募集終了日を表示しています。\n申請手続きによって募集期間は異なりますので、実際の募集期間は詳細画面にてご確認ください。",
    "I-PG-0041": "代理申請権限がある制度で絞り込まれて表示されています",
    "I-PG-0042": "まだ一時保存はされていません。",
    "I-PG-0043": "編集を続ける場合は「引き続き編集する」をクリックしてください。「引き続き編集する」をクリックすると、他の方は編集できません。\n編集を終了し、他の方も編集できるようにする場合は「編集を終了する」をクリックしてください。",
    "I-PG-0044": "該当制度で複数の委任が結ばれております。委任元と同意を得た委任関係IDを選択してください。",
    "I-PG-0045": "委任関係IDを選択後、編集を続ける場合は「引き続き編集する」をクリックしてください。「引き続き編集する」をクリックすると、他の方は編集できません。\n編集を終了し、他の方も編集できるようにする場合は「編集を終了する」をクリックしてください。",
    "I-PG-0046": "代理申請を行うため、委任元と合意した委任関係IDを選択してください。<br>委任関係IDはGビズIDのマイページから確認できます。",
    "I-PG-0047": "※複数の委任がある場合は、委任成立が新しい順に表示されます。",
    "I-PG-0048": "代理申請者から編集権限を引き戻しますか？",
    "I-PG-0049": "※この操作により代理申請者は一時的に編集不可となります。",
    "I-PG-0050": "代理申請者が編集を開始したため、引き戻すことはできません。\n再度編集したい場合は、代理申請者の確認依頼をお待ちください。",
    "I-PG-0051": "代理申請者から編集権限を引き戻しました。",
    "W-PG-0001": "入力エラーの箇所があります。エラー表示されている箇所を確認お願いします。",
    "W-PG-0002": "添付ファイルを正しく保存することができませんでした。時間をおいて、再度申請をお願いいたします。",
    "W-PG-0003": "正常に登録できていない添付ファイルがあります。クリックしてもダウンロードできない添付ファイルについて、再登録をお願いします。",
    "W-PG-0004": "テスト申請しますがよろしいですか？",
    "W-PG-0009": "別の委任先代理申請者が編集中のため、項目が編集できない状態で表示します。",
    "W-PG-0010": "委任関係IDが設定されていません。\n代理申請者情報欄の「委任関係IDの選択」ボタンから、\n委任関係IDを選択してください。",
    "W-PG-0011": "現在、{{name}}さんが編集中のため、編集できません。\n編集を行いたい場合は、{{name}}さんに編集を終了するように依頼してください。",
    "E-PG-0001": "エラーが発生し、申請することができませんでした。時間をおいて、再度申請を行ってください。",
    "E-PG-0002": "２文字以上で入力して下さい。",
    "E-PG-0003": "データは反映されていません。しばらくお待ちいただき、もう一度操作をお願いいたします。",
    "E-PG-0004": "表示権限がありません。",
    "E-PG-0005": "エラーが発生し、削除することができませんでした。時間をおいて、再度削除を行ってください。",
    "E-PG-0006": "エラーが発生し、問合せすることができませんでした。時間をおいて、再度問合せを行ってください。",
    "E-PG-0007": "エラーが発生し、問合せを下書き保存することができませんでした。時間をおいて、再度下書き保存を行ってください。",
    "E-PG-0008": "委任関係が解除されているため、確認依頼できません。GビズIDにて委任を再度おこなってください。",
    "E-PG-0009": "委任関係が解除されているため、代理で操作できません。",
    "E-PG-0010": "この補助金は代理申請が許可されていないため、確認依頼できません。事務局に問合せしてください。",
    "E-PG-0011": "この補助金は代理申請が許可されていないため、申請できません。事務局に問合せしてください。",
    "E-PG-0012": "委任関係が解除されているため、代理申請できません。GビズIDにて委任を再度おこなってください",
    "E-PG-0013": "この補助金は代理申請が許可されていないため、代理操作中は申請作成画面を開けません。",
    "E-PG-0014": "この補助金は代理申請が許可されていないため、代理操作中は補助金詳細画面を開けません。",
    "E-PG-0015": "エラーが発生し、処理に失敗しました。時間をおいて、再度行ってください。",
    "E-PG-0016": "委任関係が解除されているため、訂正依頼できません。GビズIDにて委任を再度おこなってください。",
    "E-PG-0017": "この補助金は代理申請が許可されていないため、訂正依頼できません。事務局に問合せしてください。",
    "E-PG-0018": "この補助金は代理申請が許可されていないため、代理申請者への編集を依頼できません。事務局に問合せしてください。",
    "E-PG-0019": "代理申請者は、委任元事業者向けの通知文書を閲覧できません。\n通知文書の内容を確認する必要がある場合は、委任元事業者へ連絡してください。",
    "E-DI-0001": "入力必須の項目です。内容を登録してください。",
    "E-DI-0002": "先頭に空白文字を入力しないでください。",
    "E-DI-0003": "選択必須の項目です。選択してください。",
    "E-DI-0004": "正しい日付を入力してください。",
    "E-DI-0005": "カタカナを入力してください。",
    "E-DI-0006": "入力した内容が長すぎます。",
    "E-DI-0007": "数字を入力してください。",
    "E-DI-0009": "選択されたファイルが空白ファイルです。",
    "E-DI-0010": "補助金の事業終了期限より未来日を入力しないでください。",
    "E-DI-0011": "問合せ日Fromが問合せ日Toより後に設定されています。",
    "E-DI-0012": "添付可能ファイルの拡張子は「txt pdf doc docx xls xlsx ppt pptx jpg png zip 」です。",
    "E-DI-0013": "正しいE-mailアドレスを入力してください。",
    "E-DI-0014": "選択されたファイル名が空白です。ファイル名を設定してください。",
    "E-DI-0015": "が未入力になっています。入力お願いします。",
    "E-DI-0016": "の入力形式が誤っています。",
    "E-DI-0017": "桁の数字で入力してください。",
    "E-DI-0018": "桁以下の数字で入力してください。",
    "E-DI-0019": "が選択されていません。選択お願いします。",
    "E-DI-0020": "のフォーマットがあっていません。は半角カナ、英大文字(A～Z)、数字(0～9)、スペース、（、）、ー(ハイフン)、．(ピリオド)のみ許容しています。",
    "E-DI-0021": "が長すぎます。",
    "E-DI-0022": "文字以内で入力してください。",
    "E-DI-0023": "預貯金種別と記号を正しく入力してください。",
    "E-DI-0024": "記号の先頭文字を正しく入力してください。",
    "E-DI-0025": "記号と支店を正しく入力してください。",
    "E-DI-0026": "記号と番号を正しく入力してください。",
    "E-DI-0027": "URLを入力してください。",
    "E-DI-0028": "電子ロッカーのURLを入力してください。",
    "E-DI-0029": "URLは100文字以内で入力してください。",
    "E-DI-0030": "パスワードを入力してください。",
    "E-DI-0031": "パスワードは12文字以内で入力してください。",
    "E-DI-0032": "の入力形式が誤っています。タブ文字は使用できません",
    "E-IF-0001": "検索キーワードは2文字以上255文字以内で入力してください。",
    "E-IF-0002": "ソート項目は作成日、募集開始日時しか指定できません。",
    "E-IF-0003": "募集期間内のみ区分は0と1しか指定できません。",
    "E-IF-0004": "GビズIDの認証に失敗しました。管理者にお問い合わせください。",
    "E-IF-0005": "セッションの有効時間が経過しました。再ログインが必要です。",
    "E-IF-0006": "GビズIDからお客様情報を取得できませんでした。管理者にお問い合わせください。",
    "E-IF-0007": "本システムを利用可能なGビズIDのアカウント種別ではありません。",
    "E-IF-0008": "本システムを利用可能なGビズIDのメンバーではありません。",
    "E-IF-0009": "複数選択項目は配列しか指定できません。",
    "E-ML-0001": "補助金の申請可能期間外です。",
    "E-ML-0002": "対象プロセスの実施権限がありません。",
    "E-ML-0003": "データが見つかりません。",
    "E-ML-0004": "事業者として既に申請済みのため、新規で申請できません。",
    "E-ML-0005": "申請した内容の事業終了日が事業終了期限より未来日を入力しないでください。",
    "E-ML-0006": "ミラサポプラスから電子申請情報の取得時に異常が発生しました。",
    "E-ML-0007": "概算払請求額は、概算払済額計と合わせて、交付決定時の補助金確定額を超えない値を入力してください。",
    "E-ML-0008": "申請しようとした手続きは、現在、審査中です。",
    "E-ML-0009": "申請しようとした手続きは、現在、申請することができません。\n事業の詳細から提出可能な申請であることを再度確認してください。\nもしくは事務局に問合せしてください。",
    "E-ML-0010": "暫定プライムＩＤでの申請はできません。",
    "E-ML-0011": "既に削除済みのため更新できません。",
    "E-ML-0012": "登録されている情報に不整合があります。事務局に問合せしてください。",
    "E-ML-0101": "リクエストされた内容とサーバーに登録されている項目が一致していません。",
    "E-ML-0102": "更新日時が一致していません。",
    "E-ML-0103": "データの更新に失敗しました。",
    "E-ML-0104": "登録されている情報が不正です。",
    "E-ML-0105": "データの取得に失敗しました。",
    "E-ML-0106": "他のユーザまたはシステムによる更新があったため保存できませんでした。\n画面を再読み込みして、編集可能な状態になってから編集/保存してください。",
    "E-ML-9999": "ただいま混み合っております。\nもうしばらくお待ちいただき操作をお願いいたします。"
  },
  "POPUP": {
    "TITLE": {
      "ERROR": "エラー",
      "WARNING": "注意",
      "INFO": "お知らせ",
      "NOTIFY": "通知",
      "COMPLETE": "完了",
      "ASSIGNED": "一時保存",
      "DELEGATION_NO": "委任関係ID"
    }
  },
  "PROGRESS": {
    "TITLE": "現在保存処理中です",
    "CONTENT": "保存が完了する前に他の操作をすると正常に保存できません。"
  },
  "PROGRESS_DELEGATE_EDIT": {
    "TITLE": "データ編集準備中...",
    "CONTENT": "編集可能にするための処理中です。完了までしばらくお待ちください。他の操作は行わないでください。"
  },
  "PROGRESS_DELEGATE_WITHDRAW": {
    "TITLE": "申請の取り下げ中...",
    "CONTENT": "取り下げ処理中です。完了までしばらくお待ちください。他の操作は行わないでください。"
  },
  "COMPANY_OPTIONS": {
    "LARGE": [
      {
        "code": "A",
        "value": "農業、林業"
      },
      {
        "code": "B",
        "value": "漁業"
      },
      {
        "code": "C",
        "value": "鉱業、採石業、砂利採取業"
      },
      {
        "code": "D",
        "value": "建設業"
      },
      {
        "code": "E",
        "value": "製造業"
      },
      {
        "code": "F",
        "value": "電気・ガス・熱供給・水道業"
      },
      {
        "code": "G",
        "value": "情報通信業"
      },
      {
        "code": "H",
        "value": "運輸業、郵便業"
      },
      {
        "code": "I",
        "value": "卸売業、小売業"
      },
      {
        "code": "J",
        "value": "金融業、保険業"
      },
      {
        "code": "K",
        "value": "不動産業、物品賃貸業"
      },
      {
        "code": "L",
        "value": "学術研究、専門・技術サービス業"
      },
      {
        "code": "M",
        "value": "宿泊業、飲食サービス業"
      },
      {
        "code": "N",
        "value": "生活関連サービス業、娯楽業"
      },
      {
        "code": "O",
        "value": "教育、学習支援業"
      },
      {
        "code": "P",
        "value": "医療、福祉"
      },
      {
        "code": "Q",
        "value": "複合サービス事業"
      },
      {
        "code": "R",
        "value": "サービス業（他に分類されないもの）"
      },
      {
        "code": "S",
        "value": "公務（他に分類されるものを除く）"
      },
      {
        "code": "T",
        "value": "分類不能の産業"
      }
    ],
    "MIDDLE": [
      {
        "parentCode": "A",
        "code": "1",
        "value": "農業"
      },
      {
        "parentCode": "A",
        "code": "2",
        "value": "林業"
      },
      {
        "parentCode": "B",
        "code": "3",
        "value": "漁業（水産養殖業を除く）"
      },
      {
        "parentCode": "B",
        "code": "4",
        "value": "水産養殖業"
      },
      {
        "parentCode": "C",
        "code": "5",
        "value": "鉱業、採石業、砂利採取業"
      },
      {
        "parentCode": "D",
        "code": "6",
        "value": "総合工事業"
      },
      {
        "parentCode": "D",
        "code": "7",
        "value": "職別工事業(設備工事業を除く)"
      },
      {
        "parentCode": "D",
        "code": "8",
        "value": "設備工事業"
      },
      {
        "parentCode": "E",
        "code": "9",
        "value": "食料品製造業"
      },
      {
        "parentCode": "E",
        "code": "10",
        "value": "飲料・たばこ・飼料製造業"
      },
      {
        "parentCode": "E",
        "code": "11",
        "value": "繊維工業"
      },
      {
        "parentCode": "E",
        "code": "12",
        "value": "木材・木製品製造業（家具を除く）"
      },
      {
        "parentCode": "E",
        "code": "13",
        "value": "家具・装備品製造業"
      },
      {
        "parentCode": "E",
        "code": "14",
        "value": "パルプ・紙・紙加工品製造業"
      },
      {
        "parentCode": "E",
        "code": "15",
        "value": "印刷・同関連業"
      },
      {
        "parentCode": "E",
        "code": "16",
        "value": "化学工業"
      },
      {
        "parentCode": "E",
        "code": "17",
        "value": "石油製品・石炭製品製造業"
      },
      {
        "parentCode": "E",
        "code": "18",
        "value": "プラスチック製品製造業（別掲を除く）"
      },
      {
        "parentCode": "E",
        "code": "19",
        "value": "ゴム製品製造業"
      },
      {
        "parentCode": "E",
        "code": "20",
        "value": "なめし革・同製品・毛皮製造業"
      },
      {
        "parentCode": "E",
        "code": "21",
        "value": "窯業・土石製品製造業"
      },
      {
        "parentCode": "E",
        "code": "22",
        "value": "鉄鋼業"
      },
      {
        "parentCode": "E",
        "code": "23",
        "value": "非鉄金属製造業"
      },
      {
        "parentCode": "E",
        "code": "24",
        "value": "金属製品製造業"
      },
      {
        "parentCode": "E",
        "code": "25",
        "value": "はん用機械器具製造業"
      },
      {
        "parentCode": "E",
        "code": "26",
        "value": "生産用機械器具製造業"
      },
      {
        "parentCode": "E",
        "code": "27",
        "value": "業務用機械器具製造業"
      },
      {
        "parentCode": "E",
        "code": "28",
        "value": "電子部品・デバイス・電子回路製造業"
      },
      {
        "parentCode": "E",
        "code": "29",
        "value": "電気機械器具製造業"
      },
      {
        "parentCode": "E",
        "code": "30",
        "value": "情報通信機械器具製造業"
      },
      {
        "parentCode": "E",
        "code": "31",
        "value": "輸送用機械器具製造業"
      },
      {
        "parentCode": "E",
        "code": "32",
        "value": "その他の製造業"
      },
      {
        "parentCode": "F",
        "code": "33",
        "value": "電気業"
      },
      {
        "parentCode": "F",
        "code": "34",
        "value": "ガス業"
      },
      {
        "parentCode": "F",
        "code": "35",
        "value": "熱供給業"
      },
      {
        "parentCode": "F",
        "code": "36",
        "value": "水道業"
      },
      {
        "parentCode": "G",
        "code": "37",
        "value": "通信業"
      },
      {
        "parentCode": "G",
        "code": "38",
        "value": "放送業"
      },
      {
        "parentCode": "G",
        "code": "39",
        "value": "情報サービス業"
      },
      {
        "parentCode": "G",
        "code": "40",
        "value": "インターネット附随サービス業"
      },
      {
        "parentCode": "G",
        "code": "41",
        "value": "映像・音声・文字情報制作業"
      },
      {
        "parentCode": "H",
        "code": "42",
        "value": "鉄道業"
      },
      {
        "parentCode": "H",
        "code": "43",
        "value": "道路旅客運送業"
      },
      {
        "parentCode": "H",
        "code": "44",
        "value": "道路貨物運送業"
      },
      {
        "parentCode": "H",
        "code": "45",
        "value": "水運業"
      },
      {
        "parentCode": "H",
        "code": "46",
        "value": "航空運輸業"
      },
      {
        "parentCode": "H",
        "code": "47",
        "value": "倉庫業"
      },
      {
        "parentCode": "H",
        "code": "48",
        "value": "運輸に附帯するサービス業"
      },
      {
        "parentCode": "H",
        "code": "49",
        "value": "郵便業（信書便事業を含む）"
      },
      {
        "parentCode": "I",
        "code": "50",
        "value": "各種商品卸売業"
      },
      {
        "parentCode": "I",
        "code": "51",
        "value": "繊維・衣服等卸売業"
      },
      {
        "parentCode": "I",
        "code": "52",
        "value": "飲食料品卸売業"
      },
      {
        "parentCode": "I",
        "code": "53",
        "value": "建築材料，鉱物・金属材料等卸売業"
      },
      {
        "parentCode": "I",
        "code": "54",
        "value": "機械器具卸売業"
      },
      {
        "parentCode": "I",
        "code": "55",
        "value": "その他の卸売業"
      },
      {
        "parentCode": "I",
        "code": "56",
        "value": "各種商品小売業"
      },
      {
        "parentCode": "I",
        "code": "57",
        "value": "織物・衣服・身の回り品小売業"
      },
      {
        "parentCode": "I",
        "code": "58",
        "value": "飲食料品小売業"
      },
      {
        "parentCode": "I",
        "code": "59",
        "value": "機械器具小売業"
      },
      {
        "parentCode": "I",
        "code": "60",
        "value": "その他の小売業"
      },
      {
        "parentCode": "I",
        "code": "61",
        "value": "無店舗小売業"
      },
      {
        "parentCode": "J",
        "code": "62",
        "value": "銀行業"
      },
      {
        "parentCode": "J",
        "code": "63",
        "value": "協同組織金融業"
      },
      {
        "parentCode": "J",
        "code": "64",
        "value": "貸金業，クレジットカード業等非預金信用機関"
      },
      {
        "parentCode": "J",
        "code": "65",
        "value": "金融商品取引業，商品先物取引業"
      },
      {
        "parentCode": "J",
        "code": "66",
        "value": "補助的金融業等"
      },
      {
        "parentCode": "J",
        "code": "67",
        "value": "保険業（保険媒介代理業，保険サービス業を含む）"
      },
      {
        "parentCode": "K",
        "code": "68",
        "value": "不動産取引業"
      },
      {
        "parentCode": "K",
        "code": "69",
        "value": "不動産賃貸業・管理業"
      },
      {
        "parentCode": "K",
        "code": "70",
        "value": "物品賃貸業"
      },
      {
        "parentCode": "L",
        "code": "71",
        "value": "学術・開発研究機関"
      },
      {
        "parentCode": "L",
        "code": "72",
        "value": "専門サービス業（他に分類されないもの）"
      },
      {
        "parentCode": "L",
        "code": "73",
        "value": "広告業"
      },
      {
        "parentCode": "L",
        "code": "74",
        "value": "技術サービス業（他に分類されないもの）"
      },
      {
        "parentCode": "M",
        "code": "75",
        "value": "宿泊業"
      },
      {
        "parentCode": "M",
        "code": "76",
        "value": "飲食店"
      },
      {
        "parentCode": "M",
        "code": "77",
        "value": "持ち帰り・配達飲食サービス業"
      },
      {
        "parentCode": "N",
        "code": "78",
        "value": "洗濯・理容・美容・浴場業"
      },
      {
        "parentCode": "N",
        "code": "79",
        "value": "その他の生活関連サービス業"
      },
      {
        "parentCode": "N",
        "code": "80",
        "value": "娯楽業"
      },
      {
        "parentCode": "O",
        "code": "81",
        "value": "学校教育"
      },
      {
        "parentCode": "O",
        "code": "82",
        "value": "その他の教育，学習支援業"
      },
      {
        "parentCode": "P",
        "code": "83",
        "value": "医療業"
      },
      {
        "parentCode": "P",
        "code": "84",
        "value": "保健衛生"
      },
      {
        "parentCode": "P",
        "code": "85",
        "value": "社会保険・社会福祉・介護事業"
      },
      {
        "parentCode": "Q",
        "code": "86",
        "value": "郵便局"
      },
      {
        "parentCode": "Q",
        "code": "87",
        "value": "協同組合（他に分類されないもの）"
      },
      {
        "parentCode": "R",
        "code": "88",
        "value": "廃棄物処理業"
      },
      {
        "parentCode": "R",
        "code": "89",
        "value": "自動車整備業"
      },
      {
        "parentCode": "R",
        "code": "90",
        "value": "機械等修理業（別掲を除く）"
      },
      {
        "parentCode": "R",
        "code": "91",
        "value": "職業紹介・労働者派遣業"
      },
      {
        "parentCode": "R",
        "code": "92",
        "value": "その他の事業サービス業"
      },
      {
        "parentCode": "R",
        "code": "93",
        "value": "政治・経済・文化団体"
      },
      {
        "parentCode": "R",
        "code": "94",
        "value": "宗教"
      },
      {
        "parentCode": "R",
        "code": "95",
        "value": "その他のサービス業"
      },
      {
        "parentCode": "R",
        "code": "96",
        "value": "外国公務"
      },
      {
        "parentCode": "S",
        "code": "97",
        "value": "国家公務"
      },
      {
        "parentCode": "S",
        "code": "98",
        "value": "地方公務"
      },
      {
        "parentCode": "T",
        "code": "99",
        "value": "分類不能の産業"
      }
    ],
    "SMALL": [
      {
        "parentCode": "1",
        "code": "10",
        "value": "管理，補助的経済活動を行う事業所（01農業）"
      },
      {
        "parentCode": "1",
        "code": "11",
        "value": "耕種農業"
      },
      {
        "parentCode": "1",
        "code": "12",
        "value": "畜産農業"
      },
      {
        "parentCode": "1",
        "code": "13",
        "value": "農業サービス業（園芸サービス業を除く）"
      },
      {
        "parentCode": "1",
        "code": "14",
        "value": "園芸サービス業"
      },
      {
        "parentCode": "2",
        "code": "20",
        "value": "管理，補助的経済活動を行う事業所（02林業）"
      },
      {
        "parentCode": "2",
        "code": "21",
        "value": "育林業"
      },
      {
        "parentCode": "2",
        "code": "22",
        "value": "素材生産業"
      },
      {
        "parentCode": "2",
        "code": "23",
        "value": "特用林産物生産業（きのこ類の栽培を除く）"
      },
      {
        "parentCode": "2",
        "code": "24",
        "value": "林業サービス業"
      },
      {
        "parentCode": "2",
        "code": "29",
        "value": "その他の林業"
      },
      {
        "parentCode": "3",
        "code": "30",
        "value": "管理，補助的経済活動を行う事業所（03漁業）"
      },
      {
        "parentCode": "3",
        "code": "31",
        "value": "海面漁業"
      },
      {
        "parentCode": "3",
        "code": "32",
        "value": "内水面漁業"
      },
      {
        "parentCode": "4",
        "code": "40",
        "value": "管理，補助的経済活動を行う事業所（04水産養殖業）"
      },
      {
        "parentCode": "4",
        "code": "41",
        "value": "海面養殖業"
      },
      {
        "parentCode": "4",
        "code": "42",
        "value": "内水面養殖業"
      },
      {
        "parentCode": "5",
        "code": "50",
        "value": "管理，補助的経済活動を行う事業所（05鉱業，採石業，砂利採取業）"
      },
      {
        "parentCode": "5",
        "code": "51",
        "value": "金属鉱業"
      },
      {
        "parentCode": "5",
        "code": "52",
        "value": "石炭・亜炭鉱業"
      },
      {
        "parentCode": "5",
        "code": "53",
        "value": "原油・天然ガス鉱業"
      },
      {
        "parentCode": "5",
        "code": "54",
        "value": "採石業，砂・砂利・玉石採取業"
      },
      {
        "parentCode": "5",
        "code": "55",
        "value": "窯業原料用鉱物鉱業（耐火物・陶磁器・ガラス・セメント原料用に限る）"
      },
      {
        "parentCode": "5",
        "code": "59",
        "value": "その他の鉱業"
      },
      {
        "parentCode": "6",
        "code": "60",
        "value": "管理，補助的経済活動を行う事業所（06総合工事業）"
      },
      {
        "parentCode": "6",
        "code": "61",
        "value": "一般土木建築工事業"
      },
      {
        "parentCode": "6",
        "code": "62",
        "value": "土木工事業（舗装工事業を除く）"
      },
      {
        "parentCode": "6",
        "code": "63",
        "value": "舗装工事業"
      },
      {
        "parentCode": "6",
        "code": "64",
        "value": "建築工事業(木造建築工事業を除く)"
      },
      {
        "parentCode": "6",
        "code": "65",
        "value": "木造建築工事業"
      },
      {
        "parentCode": "6",
        "code": "66",
        "value": "建築リフォーム工事業"
      },
      {
        "parentCode": "7",
        "code": "70",
        "value": "管理，補助的経済活動を行う事業所（07職別工事業）"
      },
      {
        "parentCode": "7",
        "code": "71",
        "value": "大工工事業"
      },
      {
        "parentCode": "7",
        "code": "72",
        "value": "とび・土工・コンクリート工事業"
      },
      {
        "parentCode": "7",
        "code": "73",
        "value": "鉄骨・鉄筋工事業"
      },
      {
        "parentCode": "7",
        "code": "74",
        "value": "石工・れんが・タイル・ブロック工事業"
      },
      {
        "parentCode": "7",
        "code": "75",
        "value": "左官工事業"
      },
      {
        "parentCode": "7",
        "code": "76",
        "value": "板金・金物工事業"
      },
      {
        "parentCode": "7",
        "code": "77",
        "value": "塗装工事業"
      },
      {
        "parentCode": "7",
        "code": "78",
        "value": "床・内装工事業"
      },
      {
        "parentCode": "7",
        "code": "79",
        "value": "その他の職別工事業"
      },
      {
        "parentCode": "8",
        "code": "80",
        "value": "管理，補助的経済活動を行う事業所（08設備工事業）"
      },
      {
        "parentCode": "8",
        "code": "81",
        "value": "電気工事業"
      },
      {
        "parentCode": "8",
        "code": "82",
        "value": "電気通信・信号装置工事業"
      },
      {
        "parentCode": "8",
        "code": "83",
        "value": "管工事業（さく井工事業を除く）"
      },
      {
        "parentCode": "8",
        "code": "84",
        "value": "機械器具設置工事業"
      },
      {
        "parentCode": "8",
        "code": "89",
        "value": "その他の設備工事業"
      },
      {
        "parentCode": "9",
        "code": "90",
        "value": "管理，補助的経済活動を行う事業所（09食料品製造業）"
      },
      {
        "parentCode": "9",
        "code": "91",
        "value": "畜産食料品製造業"
      },
      {
        "parentCode": "9",
        "code": "92",
        "value": "水産食料品製造業"
      },
      {
        "parentCode": "9",
        "code": "93",
        "value": "野菜缶詰・果実缶詰・農産保存食料品製造業"
      },
      {
        "parentCode": "9",
        "code": "94",
        "value": "調味料製造業"
      },
      {
        "parentCode": "9",
        "code": "95",
        "value": "糖類製造業"
      },
      {
        "parentCode": "9",
        "code": "96",
        "value": "精穀・製粉業"
      },
      {
        "parentCode": "9",
        "code": "97",
        "value": "パン・菓子製造業"
      },
      {
        "parentCode": "9",
        "code": "98",
        "value": "動植物油脂製造業"
      },
      {
        "parentCode": "9",
        "code": "99",
        "value": "その他の食料品製造業"
      },
      {
        "parentCode": "10",
        "code": "100",
        "value": "管理，補助的経済活動を行う事業所（10飲料・たばこ・飼料製造業）"
      },
      {
        "parentCode": "10",
        "code": "101",
        "value": "清涼飲料製造業"
      },
      {
        "parentCode": "10",
        "code": "102",
        "value": "酒類製造業"
      },
      {
        "parentCode": "10",
        "code": "103",
        "value": "茶・コーヒー製造業（清涼飲料を除く）"
      },
      {
        "parentCode": "10",
        "code": "104",
        "value": "製氷業"
      },
      {
        "parentCode": "10",
        "code": "105",
        "value": "たばこ製造業"
      },
      {
        "parentCode": "10",
        "code": "106",
        "value": "飼料・有機質肥料製造業"
      },
      {
        "parentCode": "11",
        "code": "110",
        "value": "管理，補助的経済活動を行う事業所（11繊維工業）"
      },
      {
        "parentCode": "11",
        "code": "111",
        "value": "製糸業，紡績業，化学繊維・ねん糸等製造業"
      },
      {
        "parentCode": "11",
        "code": "112",
        "value": "織物業"
      },
      {
        "parentCode": "11",
        "code": "113",
        "value": "ニット生地製造業"
      },
      {
        "parentCode": "11",
        "code": "114",
        "value": "染色整理業"
      },
      {
        "parentCode": "11",
        "code": "115",
        "value": "綱・網・レース・繊維粗製品製造業"
      },
      {
        "parentCode": "11",
        "code": "116",
        "value": "外衣・シャツ製造業（和式を除く）"
      },
      {
        "parentCode": "11",
        "code": "117",
        "value": "下着類製造業"
      },
      {
        "parentCode": "11",
        "code": "118",
        "value": "和装製品・その他の衣服・繊維製身の回り品製造業"
      },
      {
        "parentCode": "11",
        "code": "119",
        "value": "その他の繊維製品製造業"
      },
      {
        "parentCode": "12",
        "code": "120",
        "value": "管理，補助的経済活動を行う事業所（12木材・木製品製造業）"
      },
      {
        "parentCode": "12",
        "code": "121",
        "value": "製材業，木製品製造業"
      },
      {
        "parentCode": "12",
        "code": "122",
        "value": "造作材・合板・建築用組立材料製造業"
      },
      {
        "parentCode": "12",
        "code": "123",
        "value": "木製容器製造業（竹，とうを含む）"
      },
      {
        "parentCode": "12",
        "code": "129",
        "value": "その他の木製品製造業(竹，とうを含む)"
      },
      {
        "parentCode": "13",
        "code": "130",
        "value": "管理，補助的経済活動を行う事業所（13家具・装備品製造業）"
      },
      {
        "parentCode": "13",
        "code": "131",
        "value": "家具製造業"
      },
      {
        "parentCode": "13",
        "code": "132",
        "value": "宗教用具製造業"
      },
      {
        "parentCode": "13",
        "code": "133",
        "value": "建具製造業"
      },
      {
        "parentCode": "13",
        "code": "139",
        "value": "その他の家具・装備品製造業"
      },
      {
        "parentCode": "14",
        "code": "140",
        "value": "管理，補助的経済活動を行う事業所（14パルプ・紙・紙加工品製造業）"
      },
      {
        "parentCode": "14",
        "code": "141",
        "value": "パルプ製造業"
      },
      {
        "parentCode": "14",
        "code": "142",
        "value": "紙製造業"
      },
      {
        "parentCode": "14",
        "code": "143",
        "value": "加工紙製造業"
      },
      {
        "parentCode": "14",
        "code": "144",
        "value": "紙製品製造業"
      },
      {
        "parentCode": "14",
        "code": "145",
        "value": "紙製容器製造業"
      },
      {
        "parentCode": "14",
        "code": "149",
        "value": "その他のパルプ・紙・紙加工品製造業"
      },
      {
        "parentCode": "15",
        "code": "150",
        "value": "管理，補助的経済活動を行う事業所（15印刷・同関連業）"
      },
      {
        "parentCode": "15",
        "code": "151",
        "value": "印刷業"
      },
      {
        "parentCode": "15",
        "code": "152",
        "value": "製版業"
      },
      {
        "parentCode": "15",
        "code": "153",
        "value": "製本業，印刷物加工業"
      },
      {
        "parentCode": "15",
        "code": "159",
        "value": "印刷関連サービス業"
      },
      {
        "parentCode": "16",
        "code": "160",
        "value": "管理，補助的経済活動を行う事業所（16化学工業）"
      },
      {
        "parentCode": "16",
        "code": "161",
        "value": "化学肥料製造業"
      },
      {
        "parentCode": "16",
        "code": "162",
        "value": "無機化学工業製品製造業"
      },
      {
        "parentCode": "16",
        "code": "163",
        "value": "有機化学工業製品製造業"
      },
      {
        "parentCode": "16",
        "code": "164",
        "value": "油脂加工製品・石けん・合成洗剤・界面活性剤・塗料製造業"
      },
      {
        "parentCode": "16",
        "code": "165",
        "value": "医薬品製造業"
      },
      {
        "parentCode": "16",
        "code": "166",
        "value": "化粧品・歯磨・その他の化粧用調整品製造業"
      },
      {
        "parentCode": "16",
        "code": "169",
        "value": "その他の化学工業"
      },
      {
        "parentCode": "17",
        "code": "170",
        "value": "管理，補助的経済活動を行う事業所（17石油製品・石炭製品製造業）"
      },
      {
        "parentCode": "17",
        "code": "171",
        "value": "石油精製業"
      },
      {
        "parentCode": "17",
        "code": "172",
        "value": "潤滑油・グリース製造業（石油精製業によらないもの）"
      },
      {
        "parentCode": "17",
        "code": "173",
        "value": "コークス製造業"
      },
      {
        "parentCode": "17",
        "code": "174",
        "value": "舗装材料製造業"
      },
      {
        "parentCode": "17",
        "code": "179",
        "value": "その他の石油製品・石炭製品製造業"
      },
      {
        "parentCode": "18",
        "code": "180",
        "value": "管理，補助的経済活動を行う事業所（18プラスチック製品製造業）"
      },
      {
        "parentCode": "18",
        "code": "181",
        "value": "プラスチック板・棒・管・継手・異形押出製品製造業"
      },
      {
        "parentCode": "18",
        "code": "182",
        "value": "プラスチックフィルム・シート・床材・合成皮革製造業"
      },
      {
        "parentCode": "18",
        "code": "183",
        "value": "工業用プラスチック製品製造業"
      },
      {
        "parentCode": "18",
        "code": "184",
        "value": "発泡・強化プラスチック製品製造業"
      },
      {
        "parentCode": "18",
        "code": "185",
        "value": "プラスチック成形材料製造業（廃プラスチックを含む）"
      },
      {
        "parentCode": "18",
        "code": "189",
        "value": "その他のプラスチック製品製造業"
      },
      {
        "parentCode": "19",
        "code": "190",
        "value": "管理，補助的経済活動を行う事業所（19ゴム製品製造業）"
      },
      {
        "parentCode": "19",
        "code": "191",
        "value": "タイヤ・チューブ製造業"
      },
      {
        "parentCode": "19",
        "code": "192",
        "value": "ゴム製・プラスチック製履物・同附属品製造業"
      },
      {
        "parentCode": "19",
        "code": "193",
        "value": "ゴムベルト・ゴムホース・工業用ゴム製品製造業"
      },
      {
        "parentCode": "19",
        "code": "199",
        "value": "その他のゴム製品製造業"
      },
      {
        "parentCode": "20",
        "code": "200",
        "value": "管理，補助的経済活動を行う事業所（20なめし革・同製品・毛皮製造業）"
      },
      {
        "parentCode": "20",
        "code": "201",
        "value": "なめし革製造業"
      },
      {
        "parentCode": "20",
        "code": "202",
        "value": "工業用革製品製造業（手袋を除く）"
      },
      {
        "parentCode": "20",
        "code": "203",
        "value": "革製履物用材料・同附属品製造業"
      },
      {
        "parentCode": "20",
        "code": "204",
        "value": "革製履物製造業"
      },
      {
        "parentCode": "20",
        "code": "205",
        "value": "革製手袋製造業"
      },
      {
        "parentCode": "20",
        "code": "206",
        "value": "かばん製造業"
      },
      {
        "parentCode": "20",
        "code": "207",
        "value": "袋物製造業"
      },
      {
        "parentCode": "20",
        "code": "208",
        "value": "毛皮製造業"
      },
      {
        "parentCode": "20",
        "code": "209",
        "value": "その他のなめし革製品製造業"
      },
      {
        "parentCode": "21",
        "code": "210",
        "value": "管理，補助的経済活動を行う事業所（21窯業・土石製品製造業）"
      },
      {
        "parentCode": "21",
        "code": "211",
        "value": "ガラス・同製品製造業"
      },
      {
        "parentCode": "21",
        "code": "212",
        "value": "セメント・同製品製造業"
      },
      {
        "parentCode": "21",
        "code": "213",
        "value": "建設用粘土製品製造業（陶磁器製を除く)"
      },
      {
        "parentCode": "21",
        "code": "214",
        "value": "陶磁器・同関連製品製造業"
      },
      {
        "parentCode": "21",
        "code": "215",
        "value": "耐火物製造業"
      },
      {
        "parentCode": "21",
        "code": "216",
        "value": "炭素・黒鉛製品製造業"
      },
      {
        "parentCode": "21",
        "code": "217",
        "value": "研磨材・同製品製造業"
      },
      {
        "parentCode": "21",
        "code": "218",
        "value": "骨材・石工品等製造業"
      },
      {
        "parentCode": "21",
        "code": "219",
        "value": "その他の窯業・土石製品製造業"
      },
      {
        "parentCode": "22",
        "code": "220",
        "value": "管理，補助的経済活動を行う事業所（22鉄鋼業）"
      },
      {
        "parentCode": "22",
        "code": "221",
        "value": "製鉄業"
      },
      {
        "parentCode": "22",
        "code": "222",
        "value": "製鋼・製鋼圧延業"
      },
      {
        "parentCode": "22",
        "code": "223",
        "value": "製鋼を行わない鋼材製造業（表面処理鋼材を除く）"
      },
      {
        "parentCode": "22",
        "code": "224",
        "value": "表面処理鋼材製造業"
      },
      {
        "parentCode": "22",
        "code": "225",
        "value": "鉄素形材製造業"
      },
      {
        "parentCode": "22",
        "code": "229",
        "value": "その他の鉄鋼業"
      },
      {
        "parentCode": "23",
        "code": "230",
        "value": "管理，補助的経済活動を行う事業所（23非鉄金属製造業）"
      },
      {
        "parentCode": "23",
        "code": "231",
        "value": "非鉄金属第1次製錬・精製業"
      },
      {
        "parentCode": "23",
        "code": "232",
        "value": "非鉄金属第2次製錬・精製業（非鉄金属合金製造業を含む）"
      },
      {
        "parentCode": "23",
        "code": "233",
        "value": "非鉄金属・同合金圧延業（抽伸，押出しを含む）"
      },
      {
        "parentCode": "23",
        "code": "234",
        "value": "電線・ケーブル製造業"
      },
      {
        "parentCode": "23",
        "code": "235",
        "value": "非鉄金属素形材製造業"
      },
      {
        "parentCode": "23",
        "code": "239",
        "value": "その他の非鉄金属製造業"
      },
      {
        "parentCode": "24",
        "code": "240",
        "value": "管理，補助的経済活動を行う事業所（24金属製品製造業）"
      },
      {
        "parentCode": "24",
        "code": "241",
        "value": "ブリキ缶・その他のめっき板等製品製造業"
      },
      {
        "parentCode": "24",
        "code": "242",
        "value": "洋食器・刃物・手道具・金物類製造業"
      },
      {
        "parentCode": "24",
        "code": "243",
        "value": "暖房・調理等装置,配管工事用附属品製造業"
      },
      {
        "parentCode": "24",
        "code": "244",
        "value": "建設用・建築用金属製品製造業（製缶板金業を含む)"
      },
      {
        "parentCode": "24",
        "code": "245",
        "value": "金属素形材製品製造業"
      },
      {
        "parentCode": "24",
        "code": "246",
        "value": "金属被覆・彫刻業，熱処理業（ほうろう鉄器を除く）"
      },
      {
        "parentCode": "24",
        "code": "247",
        "value": "金属線製品製造業（ねじ類を除く)"
      },
      {
        "parentCode": "24",
        "code": "248",
        "value": "ボルト・ナット・リベット・小ねじ・木ねじ等製造業"
      },
      {
        "parentCode": "24",
        "code": "249",
        "value": "その他の金属製品製造業"
      },
      {
        "parentCode": "25",
        "code": "250",
        "value": "管理，補助的経済活動を行う事業所（25はん用機械器具製造業）"
      },
      {
        "parentCode": "25",
        "code": "251",
        "value": "ボイラ・原動機製造業"
      },
      {
        "parentCode": "25",
        "code": "252",
        "value": "ポンプ・圧縮機器製造業"
      },
      {
        "parentCode": "25",
        "code": "253",
        "value": "一般産業用機械・装置製造業"
      },
      {
        "parentCode": "25",
        "code": "259",
        "value": "その他のはん用機械・同部分品製造業"
      },
      {
        "parentCode": "26",
        "code": "260",
        "value": "管理，補助的経済活動を行う事業所（26生産用機械器具製造業）"
      },
      {
        "parentCode": "26",
        "code": "261",
        "value": "農業用機械製造業（農業用器具を除く）"
      },
      {
        "parentCode": "26",
        "code": "262",
        "value": "建設機械・鉱山機械製造業"
      },
      {
        "parentCode": "26",
        "code": "263",
        "value": "繊維機械製造業"
      },
      {
        "parentCode": "26",
        "code": "264",
        "value": "生活関連産業用機械製造業"
      },
      {
        "parentCode": "26",
        "code": "265",
        "value": "基礎素材産業用機械製造業"
      },
      {
        "parentCode": "26",
        "code": "266",
        "value": "金属加工機械製造業"
      },
      {
        "parentCode": "26",
        "code": "267",
        "value": "半導体・フラットパネルディスプレイ製造装置製造業"
      },
      {
        "parentCode": "26",
        "code": "269",
        "value": "その他の生産用機械・同部分品製造業"
      },
      {
        "parentCode": "27",
        "code": "270",
        "value": "管理，補助的経済活動を行う事業所（27業務用機械器具製造業）"
      },
      {
        "parentCode": "27",
        "code": "271",
        "value": "事務用機械器具製造業"
      },
      {
        "parentCode": "27",
        "code": "272",
        "value": "サービス用・娯楽用機械器具製造業"
      },
      {
        "parentCode": "27",
        "code": "273",
        "value": "計量器・測定器・分析機器・試験機・測量機械器具・理化学機械器具製造業"
      },
      {
        "parentCode": "27",
        "code": "274",
        "value": "医療用機械器具・医療用品製造業"
      },
      {
        "parentCode": "27",
        "code": "275",
        "value": "光学機械器具・レンズ製造業"
      },
      {
        "parentCode": "27",
        "code": "276",
        "value": "武器製造業"
      },
      {
        "parentCode": "28",
        "code": "280",
        "value": "管理，補助的経済活動を行う事業所（28電子部品・デバイス・電子回路製造業）"
      },
      {
        "parentCode": "28",
        "code": "281",
        "value": "電子デバイス製造業"
      },
      {
        "parentCode": "28",
        "code": "282",
        "value": "電子部品製造業"
      },
      {
        "parentCode": "28",
        "code": "283",
        "value": "記録メディア製造業"
      },
      {
        "parentCode": "28",
        "code": "284",
        "value": "電子回路製造業"
      },
      {
        "parentCode": "28",
        "code": "285",
        "value": "ユニット部品製造業"
      },
      {
        "parentCode": "28",
        "code": "289",
        "value": "その他の電子部品・デバイス・電子回路製造業"
      },
      {
        "parentCode": "29",
        "code": "290",
        "value": "管理，補助的経済活動を行う事業所（29電気機械器具製造業）"
      },
      {
        "parentCode": "29",
        "code": "291",
        "value": "発電用・送電用・配電用電気機械器具製造業"
      },
      {
        "parentCode": "29",
        "code": "292",
        "value": "産業用電気機械器具製造業"
      },
      {
        "parentCode": "29",
        "code": "293",
        "value": "民生用電気機械器具製造業"
      },
      {
        "parentCode": "29",
        "code": "294",
        "value": "電球・電気照明器具製造業"
      },
      {
        "parentCode": "29",
        "code": "295",
        "value": "電池製造業"
      },
      {
        "parentCode": "29",
        "code": "296",
        "value": "電子応用装置製造業"
      },
      {
        "parentCode": "29",
        "code": "297",
        "value": "電気計測器製造業"
      },
      {
        "parentCode": "29",
        "code": "299",
        "value": "その他の電気機械器具製造業"
      },
      {
        "parentCode": "30",
        "code": "300",
        "value": "管理，補助的経済活動を行う事業所（30情報通信機械器具製造業）"
      },
      {
        "parentCode": "30",
        "code": "301",
        "value": "通信機械器具・同関連機械器具製造業"
      },
      {
        "parentCode": "30",
        "code": "302",
        "value": "映像・音響機械器具製造業"
      },
      {
        "parentCode": "30",
        "code": "303",
        "value": "電子計算機・同附属装置製造業"
      },
      {
        "parentCode": "31",
        "code": "310",
        "value": "管理，補助的経済活動を行う事業所（31輸送用機械器具製造業）"
      },
      {
        "parentCode": "31",
        "code": "311",
        "value": "自動車・同附属品製造業"
      },
      {
        "parentCode": "31",
        "code": "312",
        "value": "鉄道車両・同部分品製造業"
      },
      {
        "parentCode": "31",
        "code": "313",
        "value": "船舶製造・修理業，舶用機関製造業"
      },
      {
        "parentCode": "31",
        "code": "314",
        "value": "航空機・同附属品製造業"
      },
      {
        "parentCode": "31",
        "code": "315",
        "value": "産業用運搬車両・同部分品・附属品製造業"
      },
      {
        "parentCode": "31",
        "code": "319",
        "value": "その他の輸送用機械器具製造業"
      },
      {
        "parentCode": "32",
        "code": "320",
        "value": "管理，補助的経済活動を行う事業所（32その他の製造業）"
      },
      {
        "parentCode": "32",
        "code": "321",
        "value": "貴金属・宝石製品製造業"
      },
      {
        "parentCode": "32",
        "code": "322",
        "value": "装身具・装飾品・ボタン・同関連品製造業（貴金属・宝石製を除く）"
      },
      {
        "parentCode": "32",
        "code": "323",
        "value": "時計・同部分品製造業"
      },
      {
        "parentCode": "32",
        "code": "324",
        "value": "楽器製造業"
      },
      {
        "parentCode": "32",
        "code": "325",
        "value": "がん具・運動用具製造業"
      },
      {
        "parentCode": "32",
        "code": "326",
        "value": "ペン・鉛筆・絵画用品・その他の事務用品製造業"
      },
      {
        "parentCode": "32",
        "code": "327",
        "value": "漆器製造業"
      },
      {
        "parentCode": "32",
        "code": "328",
        "value": "畳等生活雑貨製品製造業"
      },
      {
        "parentCode": "32",
        "code": "329",
        "value": "他に分類されない製造業"
      },
      {
        "parentCode": "33",
        "code": "330",
        "value": "管理，補助的経済活動を行う事業所（33電気業）"
      },
      {
        "parentCode": "33",
        "code": "331",
        "value": "電気業"
      },
      {
        "parentCode": "34",
        "code": "340",
        "value": "管理，補助的経済活動を行う事業所（34ガス業）"
      },
      {
        "parentCode": "34",
        "code": "341",
        "value": "ガス業"
      },
      {
        "parentCode": "35",
        "code": "350",
        "value": "管理，補助的経済活動を行う事業所（35熱供給業）"
      },
      {
        "parentCode": "35",
        "code": "351",
        "value": "熱供給業"
      },
      {
        "parentCode": "36",
        "code": "360",
        "value": "管理，補助的経済活動を行う事業所（36水道業）"
      },
      {
        "parentCode": "36",
        "code": "361",
        "value": "上水道業"
      },
      {
        "parentCode": "36",
        "code": "362",
        "value": "工業用水道業"
      },
      {
        "parentCode": "36",
        "code": "363",
        "value": "下水道業"
      },
      {
        "parentCode": "37",
        "code": "370",
        "value": "管理，補助的経済活動を行う事業所（37通信業）"
      },
      {
        "parentCode": "37",
        "code": "371",
        "value": "固定電気通信業"
      },
      {
        "parentCode": "37",
        "code": "372",
        "value": "移動電気通信業"
      },
      {
        "parentCode": "37",
        "code": "373",
        "value": "電気通信に附帯するサービス業"
      },
      {
        "parentCode": "38",
        "code": "380",
        "value": "管理，補助的経済活動を行う事業所（38放送業）"
      },
      {
        "parentCode": "38",
        "code": "381",
        "value": "公共放送業（有線放送業を除く）"
      },
      {
        "parentCode": "38",
        "code": "382",
        "value": "民間放送業（有線放送業を除く）"
      },
      {
        "parentCode": "38",
        "code": "383",
        "value": "有線放送業"
      },
      {
        "parentCode": "39",
        "code": "390",
        "value": "管理，補助的経済活動を行う事業所（39情報サービス業）"
      },
      {
        "parentCode": "39",
        "code": "391",
        "value": "ソフトウェア業"
      },
      {
        "parentCode": "39",
        "code": "392",
        "value": "情報処理・提供サービス業"
      },
      {
        "parentCode": "40",
        "code": "400",
        "value": "管理，補助的経済活動を行う事業所（40インターネット附随サービス業）"
      },
      {
        "parentCode": "40",
        "code": "401",
        "value": "インターネット附随サービス業"
      },
      {
        "parentCode": "41",
        "code": "410",
        "value": "管理，補助的経済活動を行う事業所（41映像・音声・文字情報制作業）"
      },
      {
        "parentCode": "41",
        "code": "411",
        "value": "映像情報制作・配給業"
      },
      {
        "parentCode": "41",
        "code": "412",
        "value": "音声情報制作業"
      },
      {
        "parentCode": "41",
        "code": "413",
        "value": "新聞業"
      },
      {
        "parentCode": "41",
        "code": "414",
        "value": "出版業"
      },
      {
        "parentCode": "41",
        "code": "415",
        "value": "広告制作業"
      },
      {
        "parentCode": "41",
        "code": "416",
        "value": "映像・音声・文字情報制作に附帯するサービス業"
      },
      {
        "parentCode": "42",
        "code": "420",
        "value": "管理，補助的経済活動を行う事業所（42鉄道業）"
      },
      {
        "parentCode": "42",
        "code": "421",
        "value": "鉄道業"
      },
      {
        "parentCode": "43",
        "code": "430",
        "value": "管理，補助的経済活動を行う事業所（43道路旅客運送業）"
      },
      {
        "parentCode": "43",
        "code": "431",
        "value": "一般乗合旅客自動車運送業"
      },
      {
        "parentCode": "43",
        "code": "432",
        "value": "一般乗用旅客自動車運送業"
      },
      {
        "parentCode": "43",
        "code": "433",
        "value": "一般貸切旅客自動車運送業"
      },
      {
        "parentCode": "43",
        "code": "439",
        "value": "その他の道路旅客運送業"
      },
      {
        "parentCode": "44",
        "code": "440",
        "value": "管理，補助的経済活動を行う事業所（44道路貨物運送業）"
      },
      {
        "parentCode": "44",
        "code": "441",
        "value": "一般貨物自動車運送業"
      },
      {
        "parentCode": "44",
        "code": "442",
        "value": "特定貨物自動車運送業"
      },
      {
        "parentCode": "44",
        "code": "443",
        "value": "貨物軽自動車運送業"
      },
      {
        "parentCode": "44",
        "code": "444",
        "value": "集配利用運送業"
      },
      {
        "parentCode": "44",
        "code": "449",
        "value": "その他の道路貨物運送業"
      },
      {
        "parentCode": "45",
        "code": "450",
        "value": "管理，補助的経済活動を行う事業所（45水運業）"
      },
      {
        "parentCode": "45",
        "code": "451",
        "value": "外航海運業"
      },
      {
        "parentCode": "45",
        "code": "452",
        "value": "沿海海運業"
      },
      {
        "parentCode": "45",
        "code": "453",
        "value": "内陸水運業"
      },
      {
        "parentCode": "45",
        "code": "454",
        "value": "船舶貸渡業"
      },
      {
        "parentCode": "46",
        "code": "460",
        "value": "管理，補助的経済活動を行う事業所（46航空運輸業）"
      },
      {
        "parentCode": "46",
        "code": "461",
        "value": "航空運送業"
      },
      {
        "parentCode": "46",
        "code": "462",
        "value": "航空機使用業（航空運送業を除く）"
      },
      {
        "parentCode": "47",
        "code": "470",
        "value": "管理，補助的経済活動を行う事業所（47倉庫業）"
      },
      {
        "parentCode": "47",
        "code": "471",
        "value": "倉庫業（冷蔵倉庫業を除く）"
      },
      {
        "parentCode": "47",
        "code": "472",
        "value": "冷蔵倉庫業"
      },
      {
        "parentCode": "48",
        "code": "480",
        "value": "管理，補助的経済活動を行う事業所（48運輸に附帯するサービス業）"
      },
      {
        "parentCode": "48",
        "code": "481",
        "value": "港湾運送業"
      },
      {
        "parentCode": "48",
        "code": "482",
        "value": "貨物運送取扱業（集配利用運送業を除く）"
      },
      {
        "parentCode": "48",
        "code": "483",
        "value": "運送代理店"
      },
      {
        "parentCode": "48",
        "code": "484",
        "value": "こん包業"
      },
      {
        "parentCode": "48",
        "code": "485",
        "value": "運輸施設提供業"
      },
      {
        "parentCode": "48",
        "code": "489",
        "value": "その他の運輸に附帯するサービス業"
      },
      {
        "parentCode": "49",
        "code": "490",
        "value": "管理，補助的経済活動を行う事業所（49郵便業）"
      },
      {
        "parentCode": "49",
        "code": "491",
        "value": "郵便業（信書便事業を含む）"
      },
      {
        "parentCode": "50",
        "code": "500",
        "value": "管理，補助的経済活動を行う事業所（50各種商品卸売業）"
      },
      {
        "parentCode": "50",
        "code": "501",
        "value": "各種商品卸売業"
      },
      {
        "parentCode": "51",
        "code": "510",
        "value": "管理，補助的経済活動を行う事業所（51繊維・衣服等卸売業）"
      },
      {
        "parentCode": "51",
        "code": "511",
        "value": "繊維品卸売業（衣服，身の回り品を除く）"
      },
      {
        "parentCode": "51",
        "code": "512",
        "value": "衣服卸売業"
      },
      {
        "parentCode": "51",
        "code": "513",
        "value": "身の回り品卸売業"
      },
      {
        "parentCode": "52",
        "code": "520",
        "value": "管理，補助的経済活動を行う事業所（52飲食料品卸売業）"
      },
      {
        "parentCode": "52",
        "code": "521",
        "value": "農畜産物・水産物卸売業"
      },
      {
        "parentCode": "52",
        "code": "522",
        "value": "食料・飲料卸売業"
      },
      {
        "parentCode": "53",
        "code": "530",
        "value": "管理，補助的経済活動を行う事業所（53建築材料，鉱物・金属材料等卸売業）"
      },
      {
        "parentCode": "53",
        "code": "531",
        "value": "建築材料卸売業"
      },
      {
        "parentCode": "53",
        "code": "532",
        "value": "化学製品卸売業"
      },
      {
        "parentCode": "53",
        "code": "533",
        "value": "石油・鉱物卸売業"
      },
      {
        "parentCode": "53",
        "code": "534",
        "value": "鉄鋼製品卸売業"
      },
      {
        "parentCode": "53",
        "code": "535",
        "value": "非鉄金属卸売業"
      },
      {
        "parentCode": "53",
        "code": "536",
        "value": "再生資源卸売業"
      },
      {
        "parentCode": "54",
        "code": "540",
        "value": "管理，補助的経済活動を行う事業所（54機械器具卸売業）"
      },
      {
        "parentCode": "54",
        "code": "541",
        "value": "産業機械器具卸売業"
      },
      {
        "parentCode": "54",
        "code": "542",
        "value": "自動車卸売業"
      },
      {
        "parentCode": "54",
        "code": "543",
        "value": "電気機械器具卸売業"
      },
      {
        "parentCode": "54",
        "code": "549",
        "value": "その他の機械器具卸売業"
      },
      {
        "parentCode": "55",
        "code": "550",
        "value": "管理，補助的経済活動を行う事業所（55その他の卸売業）"
      },
      {
        "parentCode": "55",
        "code": "551",
        "value": "家具・建具・じゅう器等卸売業"
      },
      {
        "parentCode": "55",
        "code": "552",
        "value": "医薬品・化粧品等卸売業"
      },
      {
        "parentCode": "55",
        "code": "553",
        "value": "紙・紙製品卸売業"
      },
      {
        "parentCode": "55",
        "code": "559",
        "value": "他に分類されない卸売業"
      },
      {
        "parentCode": "56",
        "code": "560",
        "value": "管理，補助的経済活動を行う事業所（56各種商品小売業）"
      },
      {
        "parentCode": "56",
        "code": "561",
        "value": "百貨店，総合スーパー"
      },
      {
        "parentCode": "56",
        "code": "569",
        "value": "その他の各種商品小売業（従業者が常時50人未満のもの）"
      },
      {
        "parentCode": "57",
        "code": "570",
        "value": "管理，補助的経済活動を行う事業所（57織物・衣服・身の回り品小売業）"
      },
      {
        "parentCode": "57",
        "code": "571",
        "value": "呉服・服地・寝具小売業"
      },
      {
        "parentCode": "57",
        "code": "572",
        "value": "男子服小売業"
      },
      {
        "parentCode": "57",
        "code": "573",
        "value": "婦人・子供服小売業"
      },
      {
        "parentCode": "57",
        "code": "574",
        "value": "靴・履物小売業"
      },
      {
        "parentCode": "57",
        "code": "579",
        "value": "その他の織物・衣服・身の回り品小売業"
      },
      {
        "parentCode": "58",
        "code": "580",
        "value": "管理，補助的経済活動を行う事業所（58飲食料品小売業）"
      },
      {
        "parentCode": "58",
        "code": "581",
        "value": "各種食料品小売業"
      },
      {
        "parentCode": "58",
        "code": "582",
        "value": "野菜・果実小売業"
      },
      {
        "parentCode": "58",
        "code": "583",
        "value": "食肉小売業"
      },
      {
        "parentCode": "58",
        "code": "584",
        "value": "鮮魚小売業"
      },
      {
        "parentCode": "58",
        "code": "585",
        "value": "酒小売業"
      },
      {
        "parentCode": "58",
        "code": "586",
        "value": "菓子・パン小売業"
      },
      {
        "parentCode": "58",
        "code": "589",
        "value": "その他の飲食料品小売業"
      },
      {
        "parentCode": "59",
        "code": "590",
        "value": "管理，補助的経済活動を行う事業所（59機械器具小売業）"
      },
      {
        "parentCode": "59",
        "code": "591",
        "value": "自動車小売業"
      },
      {
        "parentCode": "59",
        "code": "592",
        "value": "自転車小売業"
      },
      {
        "parentCode": "59",
        "code": "593",
        "value": "機械器具小売業（自動車，自転車を除く）"
      },
      {
        "parentCode": "60",
        "code": "600",
        "value": "管理，補助的経済活動を行う事業所（60その他の小売業）"
      },
      {
        "parentCode": "60",
        "code": "601",
        "value": "家具・建具・畳小売業"
      },
      {
        "parentCode": "60",
        "code": "602",
        "value": "じゅう器小売業"
      },
      {
        "parentCode": "60",
        "code": "603",
        "value": "医薬品・化粧品小売業"
      },
      {
        "parentCode": "60",
        "code": "604",
        "value": "農耕用品小売業"
      },
      {
        "parentCode": "60",
        "code": "605",
        "value": "燃料小売業"
      },
      {
        "parentCode": "60",
        "code": "606",
        "value": "書籍・文房具小売業"
      },
      {
        "parentCode": "60",
        "code": "607",
        "value": "スポーツ用品・がん具・娯楽用品・楽器小売業"
      },
      {
        "parentCode": "60",
        "code": "608",
        "value": "写真機・時計・眼鏡小売業"
      },
      {
        "parentCode": "60",
        "code": "609",
        "value": "他に分類されない小売業"
      },
      {
        "parentCode": "61",
        "code": "610",
        "value": "管理，補助的経済活動を行う事業所（61無店舗小売業）"
      },
      {
        "parentCode": "61",
        "code": "611",
        "value": "通信販売・訪問販売小売業"
      },
      {
        "parentCode": "61",
        "code": "612",
        "value": "自動販売機による小売業"
      },
      {
        "parentCode": "61",
        "code": "619",
        "value": "その他の無店舗小売業"
      },
      {
        "parentCode": "62",
        "code": "620",
        "value": "管理，補助的経済活動を行う事業所（62銀行業）"
      },
      {
        "parentCode": "62",
        "code": "621",
        "value": "中央銀行"
      },
      {
        "parentCode": "62",
        "code": "622",
        "value": "銀行（中央銀行を除く）"
      },
      {
        "parentCode": "63",
        "code": "630",
        "value": "管理，補助的経済活動を行う事業所（63協同組織金融業）"
      },
      {
        "parentCode": "63",
        "code": "631",
        "value": "中小企業等金融業"
      },
      {
        "parentCode": "63",
        "code": "632",
        "value": "農林水産金融業"
      },
      {
        "parentCode": "64",
        "code": "640",
        "value": "管理，補助的経済活動を行う事業所（64貸金業，クレジットカード業等非預金信用機関）"
      },
      {
        "parentCode": "64",
        "code": "641",
        "value": "貸金業"
      },
      {
        "parentCode": "64",
        "code": "642",
        "value": "質屋"
      },
      {
        "parentCode": "64",
        "code": "643",
        "value": "クレジットカード業，割賦金融業"
      },
      {
        "parentCode": "64",
        "code": "649",
        "value": "その他の非預金信用機関"
      },
      {
        "parentCode": "65",
        "code": "650",
        "value": "管理，補助的経済活動を行う事業所（65金融商品取引業，商品先物取引業）"
      },
      {
        "parentCode": "65",
        "code": "651",
        "value": "金融商品取引業"
      },
      {
        "parentCode": "65",
        "code": "652",
        "value": "商品先物取引業，商品投資顧問業"
      },
      {
        "parentCode": "66",
        "code": "660",
        "value": "管理，補助的経済活動を行う事業所（66補助的金融業等）"
      },
      {
        "parentCode": "66",
        "code": "661",
        "value": "補助的金融業，金融附帯業"
      },
      {
        "parentCode": "66",
        "code": "662",
        "value": "信託業"
      },
      {
        "parentCode": "66",
        "code": "663",
        "value": "金融代理業"
      },
      {
        "parentCode": "67",
        "code": "670",
        "value": "管理，補助的経済活動を行う事業所（67保険業）"
      },
      {
        "parentCode": "67",
        "code": "671",
        "value": "生命保険業"
      },
      {
        "parentCode": "67",
        "code": "672",
        "value": "損害保険業"
      },
      {
        "parentCode": "67",
        "code": "673",
        "value": "共済事業，少額短期保険業"
      },
      {
        "parentCode": "67",
        "code": "674",
        "value": "保険媒介代理業"
      },
      {
        "parentCode": "67",
        "code": "675",
        "value": "保険サービス業"
      },
      {
        "parentCode": "68",
        "code": "680",
        "value": "管理，補助的経済活動を行う事業所（68不動産取引業）"
      },
      {
        "parentCode": "68",
        "code": "681",
        "value": "建物売買業，土地売買業"
      },
      {
        "parentCode": "68",
        "code": "682",
        "value": "不動産代理業・仲介業"
      },
      {
        "parentCode": "69",
        "code": "690",
        "value": "管理，補助的経済活動を行う事業所（69不動産賃貸業・管理業）"
      },
      {
        "parentCode": "69",
        "code": "691",
        "value": "不動産賃貸業（貸家業，貸間業を除く）"
      },
      {
        "parentCode": "69",
        "code": "692",
        "value": "貸家業，貸間業"
      },
      {
        "parentCode": "69",
        "code": "693",
        "value": "駐車場業"
      },
      {
        "parentCode": "69",
        "code": "694",
        "value": "不動産管理業"
      },
      {
        "parentCode": "70",
        "code": "700",
        "value": "管理，補助的経済活動を行う事業所（70物品賃貸業）"
      },
      {
        "parentCode": "70",
        "code": "701",
        "value": "各種物品賃貸業"
      },
      {
        "parentCode": "70",
        "code": "702",
        "value": "産業用機械器具賃貸業"
      },
      {
        "parentCode": "70",
        "code": "703",
        "value": "事務用機械器具賃貸業"
      },
      {
        "parentCode": "70",
        "code": "704",
        "value": "自動車賃貸業"
      },
      {
        "parentCode": "70",
        "code": "705",
        "value": "スポーツ・娯楽用品賃貸業"
      },
      {
        "parentCode": "70",
        "code": "709",
        "value": "その他の物品賃貸業"
      },
      {
        "parentCode": "71",
        "code": "710",
        "value": "管理，補助的経済活動を行う事業所（71学術・開発研究機関）"
      },
      {
        "parentCode": "71",
        "code": "711",
        "value": "自然科学研究所"
      },
      {
        "parentCode": "71",
        "code": "712",
        "value": "人文・社会科学研究所"
      },
      {
        "parentCode": "72",
        "code": "720",
        "value": "管理，補助的経済活動を行う事業所（72専門サービス業）"
      },
      {
        "parentCode": "72",
        "code": "721",
        "value": "法律事務所，特許事務所"
      },
      {
        "parentCode": "72",
        "code": "722",
        "value": "公証人役場，司法書士事務所，土地家屋調査士事務所"
      },
      {
        "parentCode": "72",
        "code": "723",
        "value": "行政書士事務所"
      },
      {
        "parentCode": "72",
        "code": "724",
        "value": "公認会計士事務所，税理士事務所"
      },
      {
        "parentCode": "72",
        "code": "725",
        "value": "社会保険労務士事務所"
      },
      {
        "parentCode": "72",
        "code": "726",
        "value": "デザイン業"
      },
      {
        "parentCode": "72",
        "code": "727",
        "value": "著述・芸術家業"
      },
      {
        "parentCode": "72",
        "code": "728",
        "value": "経営コンサルタント業，純粋持株会社"
      },
      {
        "parentCode": "72",
        "code": "729",
        "value": "その他の専門サービス業"
      },
      {
        "parentCode": "73",
        "code": "730",
        "value": "管理，補助的経済活動を行う事業所（73広告業）"
      },
      {
        "parentCode": "73",
        "code": "731",
        "value": "広告業"
      },
      {
        "parentCode": "74",
        "code": "740",
        "value": "管理，補助的経済活動を行う事業所（74技術サービス業）"
      },
      {
        "parentCode": "74",
        "code": "741",
        "value": "獣医業"
      },
      {
        "parentCode": "74",
        "code": "742",
        "value": "土木建築サービス業"
      },
      {
        "parentCode": "74",
        "code": "743",
        "value": "機械設計業"
      },
      {
        "parentCode": "74",
        "code": "744",
        "value": "商品・非破壊検査業"
      },
      {
        "parentCode": "74",
        "code": "745",
        "value": "計量証明業"
      },
      {
        "parentCode": "74",
        "code": "746",
        "value": "写真業"
      },
      {
        "parentCode": "74",
        "code": "749",
        "value": "その他の技術サービス業"
      },
      {
        "parentCode": "75",
        "code": "750",
        "value": "管理，補助的経済活動を行う事業所（75宿泊業）"
      },
      {
        "parentCode": "75",
        "code": "751",
        "value": "旅館，ホテル"
      },
      {
        "parentCode": "75",
        "code": "752",
        "value": "簡易宿所"
      },
      {
        "parentCode": "75",
        "code": "753",
        "value": "下宿業"
      },
      {
        "parentCode": "75",
        "code": "759",
        "value": "その他の宿泊業"
      },
      {
        "parentCode": "76",
        "code": "760",
        "value": "管理，補助的経済活動を行う事業所（76飲食店）"
      },
      {
        "parentCode": "76",
        "code": "761",
        "value": "食堂，レストラン（専門料理店を除く）"
      },
      {
        "parentCode": "76",
        "code": "762",
        "value": "専門料理店"
      },
      {
        "parentCode": "76",
        "code": "763",
        "value": "そば・うどん店"
      },
      {
        "parentCode": "76",
        "code": "764",
        "value": "すし店"
      },
      {
        "parentCode": "76",
        "code": "765",
        "value": "酒場，ビヤホール"
      },
      {
        "parentCode": "76",
        "code": "766",
        "value": "バー，キャバレー，ナイトクラブ"
      },
      {
        "parentCode": "76",
        "code": "767",
        "value": "喫茶店"
      },
      {
        "parentCode": "76",
        "code": "769",
        "value": "その他の飲食店"
      },
      {
        "parentCode": "77",
        "code": "770",
        "value": "管理，補助的経済活動を行う事業所（77持ち帰り・配達飲食サービス業）"
      },
      {
        "parentCode": "77",
        "code": "771",
        "value": "持ち帰り飲食サービス業"
      },
      {
        "parentCode": "77",
        "code": "772",
        "value": "配達飲食サービス業"
      },
      {
        "parentCode": "78",
        "code": "780",
        "value": "管理，補助的経済活動を行う事業所（78洗濯・理容・美容・浴場業）"
      },
      {
        "parentCode": "78",
        "code": "781",
        "value": "洗濯業"
      },
      {
        "parentCode": "78",
        "code": "782",
        "value": "理容業"
      },
      {
        "parentCode": "78",
        "code": "783",
        "value": "美容業"
      },
      {
        "parentCode": "78",
        "code": "784",
        "value": "一般公衆浴場業"
      },
      {
        "parentCode": "78",
        "code": "785",
        "value": "その他の公衆浴場業"
      },
      {
        "parentCode": "78",
        "code": "789",
        "value": "その他の洗濯・理容・美容・浴場業"
      },
      {
        "parentCode": "79",
        "code": "790",
        "value": "管理，補助的経済活動を行う事業所（79その他の生活関連サービス業）"
      },
      {
        "parentCode": "79",
        "code": "791",
        "value": "旅行業"
      },
      {
        "parentCode": "79",
        "code": "792",
        "value": "家事サービス業"
      },
      {
        "parentCode": "79",
        "code": "793",
        "value": "衣服裁縫修理業"
      },
      {
        "parentCode": "79",
        "code": "794",
        "value": "物品預り業"
      },
      {
        "parentCode": "79",
        "code": "795",
        "value": "火葬・墓地管理業"
      },
      {
        "parentCode": "79",
        "code": "796",
        "value": "冠婚葬祭業"
      },
      {
        "parentCode": "79",
        "code": "799",
        "value": "他に分類されない生活関連サービス業"
      },
      {
        "parentCode": "80",
        "code": "800",
        "value": "管理，補助的経済活動を行う事業所（80娯楽業）"
      },
      {
        "parentCode": "80",
        "code": "801",
        "value": "映画館"
      },
      {
        "parentCode": "80",
        "code": "802",
        "value": "興行場（別掲を除く），興行団"
      },
      {
        "parentCode": "80",
        "code": "803",
        "value": "競輪・競馬等の競走場，競技団"
      },
      {
        "parentCode": "80",
        "code": "804",
        "value": "スポーツ施設提供業"
      },
      {
        "parentCode": "80",
        "code": "805",
        "value": "公園，遊園地"
      },
      {
        "parentCode": "80",
        "code": "806",
        "value": "遊戯場"
      },
      {
        "parentCode": "80",
        "code": "809",
        "value": "その他の娯楽業"
      },
      {
        "parentCode": "81",
        "code": "810",
        "value": "管理，補助的経済活動を行う事業所（81学校教育）"
      },
      {
        "parentCode": "81",
        "code": "811",
        "value": "幼稚園"
      },
      {
        "parentCode": "81",
        "code": "812",
        "value": "小学校"
      },
      {
        "parentCode": "81",
        "code": "813",
        "value": "中学校"
      },
      {
        "parentCode": "81",
        "code": "814",
        "value": "高等学校，中等教育学校"
      },
      {
        "parentCode": "81",
        "code": "815",
        "value": "特別支援学校"
      },
      {
        "parentCode": "81",
        "code": "816",
        "value": "高等教育機関"
      },
      {
        "parentCode": "81",
        "code": "817",
        "value": "専修学校，各種学校"
      },
      {
        "parentCode": "81",
        "code": "818",
        "value": "学校教育支援機関"
      },
      {
        "parentCode": "81",
        "code": "819",
        "value": "幼保連携型認定こども園"
      },
      {
        "parentCode": "82",
        "code": "820",
        "value": "管理，補助的経済活動を行う事業所（82その他の教育，学習支援業）"
      },
      {
        "parentCode": "82",
        "code": "821",
        "value": "社会教育"
      },
      {
        "parentCode": "82",
        "code": "822",
        "value": "職業・教育支援施設"
      },
      {
        "parentCode": "82",
        "code": "823",
        "value": "学習塾"
      },
      {
        "parentCode": "82",
        "code": "824",
        "value": "教養・技能教授業"
      },
      {
        "parentCode": "82",
        "code": "829",
        "value": "他に分類されない教育，学習支援業"
      },
      {
        "parentCode": "83",
        "code": "830",
        "value": "管理，補助的経済活動を行う事業所（83医療業）"
      },
      {
        "parentCode": "83",
        "code": "831",
        "value": "病院"
      },
      {
        "parentCode": "83",
        "code": "832",
        "value": "一般診療所"
      },
      {
        "parentCode": "83",
        "code": "833",
        "value": "歯科診療所"
      },
      {
        "parentCode": "83",
        "code": "834",
        "value": "助産・看護業"
      },
      {
        "parentCode": "83",
        "code": "835",
        "value": "療術業"
      },
      {
        "parentCode": "83",
        "code": "836",
        "value": "医療に附帯するサービス業"
      },
      {
        "parentCode": "84",
        "code": "840",
        "value": "管理，補助的経済活動を行う事業所（84保健衛生）"
      },
      {
        "parentCode": "84",
        "code": "841",
        "value": "保健所"
      },
      {
        "parentCode": "84",
        "code": "842",
        "value": "健康相談施設"
      },
      {
        "parentCode": "84",
        "code": "849",
        "value": "その他の保健衛生"
      },
      {
        "parentCode": "85",
        "code": "850",
        "value": "管理，補助的経済活動を行う事業所（85社会保険・社会福祉・介護事業）"
      },
      {
        "parentCode": "85",
        "code": "851",
        "value": "社会保険事業団体"
      },
      {
        "parentCode": "85",
        "code": "852",
        "value": "福祉事務所"
      },
      {
        "parentCode": "85",
        "code": "853",
        "value": "児童福祉事業"
      },
      {
        "parentCode": "85",
        "code": "854",
        "value": "老人福祉・介護事業"
      },
      {
        "parentCode": "85",
        "code": "855",
        "value": "障害者福祉事業"
      },
      {
        "parentCode": "85",
        "code": "859",
        "value": "その他の社会保険・社会福祉・介護事業"
      },
      {
        "parentCode": "86",
        "code": "860",
        "value": "管理，補助的経済活動を行う事業所（86郵便局）"
      },
      {
        "parentCode": "86",
        "code": "861",
        "value": "郵便局"
      },
      {
        "parentCode": "86",
        "code": "862",
        "value": "郵便局受託業"
      },
      {
        "parentCode": "87",
        "code": "870",
        "value": "管理，補助的経済活動を行う事業所（87協同組合）"
      },
      {
        "parentCode": "87",
        "code": "871",
        "value": "農林水産業協同組合（他に分類されないもの）"
      },
      {
        "parentCode": "87",
        "code": "872",
        "value": "事業協同組合（他に分類されないもの）"
      },
      {
        "parentCode": "88",
        "code": "880",
        "value": "管理，補助的経済活動を行う事業所（88廃棄物処理業）"
      },
      {
        "parentCode": "88",
        "code": "881",
        "value": "一般廃棄物処理業"
      },
      {
        "parentCode": "88",
        "code": "882",
        "value": "産業廃棄物処理業"
      },
      {
        "parentCode": "88",
        "code": "889",
        "value": "その他の廃棄物処理業"
      },
      {
        "parentCode": "89",
        "code": "890",
        "value": "管理，補助的経済活動を行う事業所（89自動車整備業）"
      },
      {
        "parentCode": "89",
        "code": "891",
        "value": "自動車整備業"
      },
      {
        "parentCode": "90",
        "code": "900",
        "value": "管理，補助的経済活動を行う事業所（90機械等修理業）"
      },
      {
        "parentCode": "90",
        "code": "901",
        "value": "機械修理業（電気機械器具を除く）"
      },
      {
        "parentCode": "90",
        "code": "902",
        "value": "電気機械器具修理業"
      },
      {
        "parentCode": "90",
        "code": "903",
        "value": "表具業"
      },
      {
        "parentCode": "90",
        "code": "909",
        "value": "その他の修理業"
      },
      {
        "parentCode": "91",
        "code": "910",
        "value": "管理，補助的経済活動を行う事業所（91職業紹介・労働者派遣業）"
      },
      {
        "parentCode": "91",
        "code": "911",
        "value": "職業紹介業"
      },
      {
        "parentCode": "91",
        "code": "912",
        "value": "労働者派遣業"
      },
      {
        "parentCode": "92",
        "code": "920",
        "value": "管理，補助的経済活動を行う事業所（92その他の事業サービス業）"
      },
      {
        "parentCode": "92",
        "code": "921",
        "value": "速記・ワープロ入力・複写業"
      },
      {
        "parentCode": "92",
        "code": "922",
        "value": "建物サービス業"
      },
      {
        "parentCode": "92",
        "code": "923",
        "value": "警備業"
      },
      {
        "parentCode": "92",
        "code": "929",
        "value": "他に分類されない事業サービス業"
      },
      {
        "parentCode": "93",
        "code": "931",
        "value": "経済団体"
      },
      {
        "parentCode": "93",
        "code": "932",
        "value": "労働団体"
      },
      {
        "parentCode": "93",
        "code": "933",
        "value": "学術・文化団体"
      },
      {
        "parentCode": "93",
        "code": "934",
        "value": "政治団体"
      },
      {
        "parentCode": "93",
        "code": "939",
        "value": "他に分類されない非営利的団体"
      },
      {
        "parentCode": "94",
        "code": "941",
        "value": "神道系宗教"
      },
      {
        "parentCode": "94",
        "code": "942",
        "value": "仏教系宗教"
      },
      {
        "parentCode": "94",
        "code": "943",
        "value": "キリスト教系宗教"
      },
      {
        "parentCode": "94",
        "code": "949",
        "value": "その他の宗教"
      },
      {
        "parentCode": "95",
        "code": "950",
        "value": "管理，補助的経済活動を行う事業所（95その他のサービス業）"
      },
      {
        "parentCode": "95",
        "code": "951",
        "value": "集会場"
      },
      {
        "parentCode": "95",
        "code": "952",
        "value": "と畜場"
      },
      {
        "parentCode": "95",
        "code": "959",
        "value": "他に分類されないサービス業"
      },
      {
        "parentCode": "96",
        "code": "961",
        "value": "外国公館"
      },
      {
        "parentCode": "96",
        "code": "969",
        "value": "その他の外国公務"
      },
      {
        "parentCode": "97",
        "code": "971",
        "value": "立法機関"
      },
      {
        "parentCode": "97",
        "code": "972",
        "value": "司法機関"
      },
      {
        "parentCode": "97",
        "code": "973",
        "value": "行政機関"
      },
      {
        "parentCode": "98",
        "code": "981",
        "value": "都道府県機関"
      },
      {
        "parentCode": "98",
        "code": "982",
        "value": "市町村機関"
      },
      {
        "parentCode": "99",
        "code": "999",
        "value": "分類不能の産業"
      }
    ]
  },
  "BANK_INFO": {
    "TITLE": "口座情報の管理",
    "LIST_TITLE": "口座情報",
    "SUB_TITELE": "「確認中」ステータスの口座情報は表示されません。",
    "SEARCH_WITH_KEYWORD": "キーワードを入れてください",
    "OPERATION": "操作",
    "ADD": "追加",
    "EDIT": "変更",
    "DELETE": "削除",
    "SELECT": "選択",
    "BANK_NAME": "金融機関名",
    "BRANCH_NAME": "支店名",
    "CODE": "（コード）",
    "DEPOSIT_TYPE": "預貯金種別",
    "ACCOUNT_NUMBER": "口座番号",
    "ACCOUNT_HOLDER": "口座名義",
    "KANJI": "（漢字）",
    "KANA": "（ｶﾅ）",
    "BANK_REGIST_DATE": "口座登録日",
    "BANK_INFO_STATUS": "ステータス",
    "BANK_VERIFY_DATE_1": "口座確認",
    "BANK_VERIFY_DATE_2": "実施日",
    "BANK_SETTING": "口座情報の登録・編集方法・口座確認のステータス等については、<br><a target='_blank' href='https://fs2.jgrants-portal.go.jp/操作マニュアル_事業者用.pdf'>事業者マニュアル「Ⅳ. 事業開始後の各種手続き」</a>をご参照ください。"
  },
  "BANK_INFO_DETAIL": {
    "TITLE": "振込先情報",
    "SUB_TITLE_1": "口座の使用用途を記載してください。",
    "SUB_TITLE_2": "ゆうちょ銀行を指定される場合、記号・番号を入力してください。口座番号は自動入力されます。",
    "SUB_TITLE_3": "",
    "SUB_TITLE_4": "口座名義（ｶﾅ）への入力形式については、",
    "SUB_TITLE_5": "事業者マニュアル「IV．事業開始後の各種手続き」",
    "SUB_TITLE_6": "をご参照ください。",
    "ACCOUNT_NAME": "口座名称",
    "BANK_NAME": "振込先金融機関",
    "BANK_CODE": "振込先金融機関（コード）",
    "JP_BANK_SYMBOL": "記号",
    "JP_BANK_NUMBER": "番号",
    "BRANCH_NAME": "支店名",
    "BRANCH_CODE": "支店名（コード）",
    "DEPOSIT_TYPE": "預貯金種別",
    "DEPOSIT_TYPE_0": "普通",
    "DEPOSIT_TYPE_1": "当座",
    "DEPOSIT_TYPE_4": "貯蓄",
    "ACCOUNT_NUMBER": "口座番号",
    "ACCOUNT_HOLDER_KANJI": "口座名義（漢字）",
    "ACCOUNT_HOLDER": "口座名義（ｶﾅ）",
    "NOTE": "メモ",
    "AGREE_1": "口座の存在確認、登録について、",
    "AGREE_2": "Ｊグランツ利用規約",
    "AGREE_3": "プライバシーポリシー",
    "AGREE_4": "に同意する",
    "AGREE_REQUIRED": "利用規約に同意していない場合ご利用いただけません。利用規約を確認のうえ同意してください。"
  },
  "BANK_INFO_DIALOG": {
    "TITLE": "確認",
    "DELETE_MESSAGE_1": "この口座情報を申請に利用している場合、申請情報からは口座情報は削除されません。",
    "DELETE_MESSAGE_2": "口座情報を削除しました。",
    "MISMATCH_MESSAGE_1": "口座名義（ｶﾅ）が確認できませんでした。",
    "MISMATCH_MESSAGE_2": "入力内容に誤りがないか、ご確認ください。",
    "MISMATCH_MESSAGE_3": "口座名義（ｶﾅ）は通帳等の記載に沿ってご入力ください。",
    "MISMATCH_MESSAGE_4": "なお、主に以下の場合などには、入力が正しくても口座名義（ｶﾅ）を確認できないことがあります。",
    "MISMATCH_MESSAGE_5": "　例）口座名義（ｶﾅ）が30文字を超える場合",
    "MISMATCH_MESSAGE_6": "　例）口座名義（ｶﾅ）に屋号が含まれる場合",
    "MISMATCH_MESSAGE_7": "入力内容が正しい場合は「続行」ボタン、修正する場合は「再入力」ボタンを押してください。",
    "MISMATCH_MESSAGE_8": "この口座を申請に利用する場合、事務局から通帳のコピーなど確認用の書類の提出を求められることがあります。その際は、ご提出をお願いいたします。",
    "NOACCOUNT_MESSAGE_1": "口座情報に誤りがあります。",
    "NOACCOUNT_MESSAGE_2": "入力内容をご確認の上、正しい口座情報に修正してください。",
    "UNABLE_MESSAGE_1": "この口座を申請に利用する場合、審査の際に通帳のコピーなど確認用の書類が必要になるため、申請時に書類のご提出をお願いする場合がありますので、ご留意ください。",
    "SHORTAGE_MESSAGE_1": "通信が一時的に混みあっているため、口座確認を完了できませんでした。",
    "SHORTAGE_MESSAGE_2": "お手数ですが、「再入力」から再度操作をお試しください。",
    "SHORTAGE_MESSAGE_3": "このメッセージが複数回表示される場合は「続行」ボタンを押してください。",
    "SHORTAGE_MESSAGE_4": "その場合、口座確認は翌日実施されますので、翌日12:00以降に「自社情報の確認・編集画面」の口座情報一覧でステータスをご確認ください。",
    "SHORTAGE_MESSAGE_5": "なお、この口座を申請に利用する場合、通帳のコピーなど確認用の書類の提出をお願いします。",
    "LATE_MESSAGE_1": "現在、口座確認機能が利用できません。口座確認結果は、翌日12：00以降、自社情報の確認・編集画面の口座情報一覧にて確認いただけます。"
  },
  "BANK_INFO_REQUEST": {
    "SUB_TITLE_1": "口座の使用用途を記載してください。",
    "SUB_TITLE_2": "ゆうちょ銀行を指定される場合、記号・番号を入力してください。口座番号は自動入力されます。",
    "SUB_TITLE_3": "",
    "SUB_TITLE_4": "口座名義（ｶﾅ）への入力形式については、",
    "SUB_TITLE_5": "事業者マニュアル「IV．事業開始後の各種手続き」",
    "SUB_TITLE_6": "をご参照ください。",
    "CLEAR": "口座情報をクリア",
    "SELECT": "登録口座を利用",
    "EXTERNAL_CONNECT": "外部サービスから口座情報取得"
  },
  "BANK_EXTERNAL": {
    "TITLE": "外部サービス選択",
    "DIALOG_TITLE": "確認",
    "DIALOG_ERROR_TITLE": "エラー",
    "MESSAGES": {
      "COMPLETE": "外部サービスから口座情報の取得が完了しました。",
      "ERROR_1": "外部サービスからの口座情報取得中にエラーが発生しました。",
      "ERROR_2": "時間をおいて再度口座情報の取得を行うか、振込先情報を直接入力してください。",
      "BANK_NOT_FOUND_1": "外部サービスから連携された口座情報を反映できませんでした。",
      "BANK_NOT_FOUND_2": "連携された金融機関はJグランツでは利用できません。",
      "BRANCH_NOT_FOUND_1": "外部サービスから連携された口座情報を反映できませんでした。",
      "BRANCH_NOT_FOUND_2": "連携された金融機関はJグランツでは利用できません。",
      "COMPLETE_INFO": "以下内容を確認ください。",
      "JPBANK_REQUIRED": "ゆうちょ銀行の場合、「記号」、「番号」の入力が必須となります。",
      "ACCOUNT_HOLDER_KANA_CONVERTED": "「口座名義（ｶﾅ）」は、全銀テレ為替文字以外の文字をスペースに変換しました。",
      "ACCOUNT_HOLDER_KANA_TRIMMED": "「口座名義（ｶﾅ）」が31文字を超える場合、31文字目以降は反映されません。",
      "MEMO_TRIMMED": "「メモ」が256文字を超える場合、256文字目以降は反映されません。"
    }
  },
  "DENSHI_LOCKER_INFO": {
    "URL": "https://www.gbiz.go.jp/locker",
    "PASSWORD": "パスワード"
  },
  "OFFICE_INFO": {
    "TITLE": "事業所情報の管理",
    "TITLE_LIST": "事業所情報一覧",
    "DESCRIPTION": "事業所情報の変更は「詳細」ボタンから行うことができます。",
    "CREATE_INFO_LINK_1": "事業所情報の管理は、",
    "CREATE_INFO_LINK_2": "自社情報の確認・編集",
    "CREATE_INFO_LINK_3": "から行うことができます。",
    "SELECT": "登録事業所を利用",
    "CLEAR": "事業所情報をクリア",
    "OFFICE_NAME": "事業所名称",
    "SUB_TITLE_1": "雇用保険適用事業所番号を入力してください。ハイフンは入力不要です。",
    "EI_OFFICE_ID": "雇用保険適用事業所番号",
    "EI_OFFICE_ID_1": "雇用保険",
    "EI_OFFICE_ID_2": "適用事業所番号",
    "SUB_TITLE_2": "労働保険番号を入力してください。ハイフンは入力不要です。",
    "LABOR_INSURANCE_ID": "労働保険番号",
    "POSTAL_CODE": "郵便番号",
    "PREFECTURE": "住所（都道府県）",
    "CITY": "住所（市区町村）",
    "ADDRESS": "住所（番地等）",
    "BUILDING": "住所（建物名等）",
    "PHONE_NUMBER": "電話番号",
    "SEARCH_WITH_KEYWORD": "キーワードを入れてください",
    "ADDRESS_ALL": "住所",
    "ADD": "追加",
    "OPERATION": "操作",
    "DETAIL": "詳細",
    "DELETE": "削除",
    "SELECT_DATA": "選択",
    "MODIFIED_DATE": "最終更新日",
    "CREATED_DATE": "作成日",
    "ADD_OFFICE_INFO": "入力した事業所情報を自社情報へ新規登録する",
    "SHOW_ALL": "全て表示"
  },
  "OFFICE_INFO_DETAIL": {
    "TITLE": "事業所情報",
    "SUB_TITLE_1": "雇用保険適用事業所番号を入力してください。ハイフンは入力不要です。",
    "SUB_TITLE_2": "労働保険番号を入力してください。ハイフンは入力不要です。",
    "OFFICE_NAME": "事業所名称",
    "EI_OFFICE_ID": "雇用保険適用事業所番号",
    "LABOR_INSURANCE_ID": "労働保険番号",
    "POSTAL_CODE": "郵便番号",
    "PREFECTURE": "住所（都道府県）",
    "CITY": "住所（市区町村）",
    "ADDRESS": "住所（番地等）",
    "BUILDING": "住所（建物名等）",
    "PHONE": "電話番号"
  },
  "OFFICE_INFO_DIALOG": {
    "TITLE": "注意",
    "TITLE_DONE": "完了",
    "DELETE_MESSAGE_1": "この事業所情報を削除しても、すでに作成されている申請内容はそのまま保持されます。",
    "DELETE_MESSAGE_2": "事業所情報を削除しました。",
    "DUPLICATE_MESSAGE": "入力された雇用保険適用事業所番号は、すでに登録済みです。同じ番号を重複して保存してもよろしいですか？",
    "PREFECTURE": "住所（都道府県）",
    "CITY": "住所（市区町村）",
    "ADDRESS": "住所（番地等）",
    "BUILDING": "住所（建物名等）",
    "REGIST": "保存する"
  },
  "REQUEST_DIALOG":{
    "DIALOG_TITLE": "新規申請",
    "DIALOG_1": "事故報告",
    "DIALOG_2": "計画変更承認申請",
    "DIALOG_3": "概算払請求",
    "DIALOG_4": "交付決定後の補助金申請の取り下げ",
    "DIALOG_5": "中止・廃止承認申請",
    "DIALOG_6": "精算払請求",
    "REQUEST_BUTTON": "新規申請する",
    "CANCEL_BUTTON": "キャンセル"
  },
  "REQUEST_FORM_ELEMENT": {
    "DIVIDE_BY_ZERO": "0で割ることはできません。",
    "FORM_ERROR": "計算式の形式が正しくありません。",
    "UPPER_LIMIT_ERROR": "計算結果が上限を上回っています。",
    "LOWER_LIMIT_ERROR": "計算結果が下限を下回っています。",
    "INPUT_ERROR": "計算項目に不正な値が入力されています。",
    "AUTO_CALCULATION": "自動計算"
  }
}